"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9389],{

/***/ 89777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83554);
/* harmony import */ var _components_icons_Close__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24162);
/* harmony import */ var _components_ui_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58262);
/* harmony import */ var _features_livestream_detail_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77910);
/* harmony import */ var _layouts_shared__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7806);
/* harmony import */ var _libs_app__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92517);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(65820);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15331);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74931);












var SearchPartial = function(param) {
    var t = param.t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)([]), dataSearchKey = ref[0], setDataSearchKey = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(""), keyword = ref1[0], setKeyword = ref1[1];
    var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(null);
    var ref2 = (0,_features_livestream_detail_api__WEBPACK_IMPORTED_MODULE_4__/* .useFetchLiveVideosQuery */ .fN)({
        product_keyword: keyword
    }, {
        enabled: false,
        retry: false,
        refetchOnWindowFocus: false,
        onError: function(param) {
            var message = param.message;
            react_hot_toast__WEBPACK_IMPORTED_MODULE_8__/* ["default"].error */ .ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data;
            var _data = [];
            _data = data.map(function(d) {
                var _d = {};
                var productData = d.live_stream_product.find(function(p) {
                    return p.products.product_code.toLocaleLowerCase() === keyword.toLocaleLowerCase();
                });
                _d = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, productData), {
                    link: d.link,
                    live_stream: {
                        images: d.images,
                        name: d.live_streamer.name,
                        id: d.id + "",
                        title: d.name,
                        duration: d.duration
                    }
                });
                return _d;
            });
            if (keyword) {
                setDataSearchKey(Array.isArray(_data) ? _data : []);
            }
        }
    }), refetchKeyword = ref2.refetch, loadingSearch = ref2.isLoading;
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if (keyword !== "") {
            refetchKeyword();
        } else {
            setDataSearchKey([]);
        }
    }, [
        keyword,
        refetchKeyword
    ]);
    var handleChange = function(value) {
        setKeyword(value);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var optimizedFn = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)((0,_libs_app__WEBPACK_IMPORTED_MODULE_6__/* .debounce */ .Ds)(handleChange, 300), []);
    var clearInput = function() {
        if (inputRef.current) {
            inputRef.current.value = "";
            setKeyword("");
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "tw-w-full tw-relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "tw-flex tw-rounded-5 tw-text-secondary-70 tw-border tw-overflow-hidden tw-border-primary-main tw-py-2 tw-px-3 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_Icon__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .J, {
                        className: "tw-w-6 tw-h-6",
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .SearchIcon */ .W1, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "text",
                        ref: inputRef,
                        placeholder: t("layout:label.search-keyword"),
                        className: "tw-w-full tw-outline-none tw-ml-2 tw-placeholder-secondary-70 ",
                        onChange: function(e) {
                            return optimizedFn(e.target.value);
                        }
                    }),
                    keyword && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "tw-text-primary-main tw-cursor-pointer",
                        onClick: clearInput,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_Icon__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .J, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_Close__WEBPACK_IMPORTED_MODULE_2__/* .CloseIcon */ .T, {}),
                            className: "tw-w-6 tw-h-6"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_11__/* .AnimatePresence */ .M, {
                children: keyword && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_12__/* .motion.div */ .E.div, {
                    className: "tw-absolute tw-drop-shadow tw-px-2 md:tw-px-4 tw-py-2 tw-left-0 tw-z-10 tw-bg-white tw-rounded-5 top-full-8 tw-w-full",
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    exit: {
                        opacity: 0
                    },
                    transition: {
                        duration: 0.4
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-w-full tw-h-full tw-overflow-y-scroll tw-max-h-80",
                        children: loadingSearch ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .Loading */ .gb, {}) : !dataSearchKey.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "tw-py-10 tw-text-center",
                            children: "Kh\xf4ng t\xecm thấy video"
                        }) : dataSearchKey.map(function(data) {
                            var id = data.live_stream.id;
                            var handle = "".concat((0,_libs_app__WEBPACK_IMPORTED_MODULE_6__/* .createHandle */ .UR)(data.live_stream.title), "-").concat(id);
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "tw-py-2 tw-border-b",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "tw-w-full md:tw-w-2/3",
                                    onClick: function() {
                                        return clearInput();
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
                                        url: {
                                            pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_5__/* .PagePath.LiveVideoPage */ ._.LiveVideoPage,
                                            query: {
                                                id: handle,
                                                start: data.played
                                            }
                                        },
                                        className: "tw-w-full",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "tw-py-2 tw-px-4 tw-rounded-5",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .LiveProduct */ .SK, {
                                                data: data
                                            })
                                        })
                                    })
                                })
                            }, "live" + id);
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_7__.memo)(SearchPartial));


/***/ }),

/***/ 30161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ VideoLoop; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _layouts_shared__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7806);
/* harmony import */ var _libs_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83554);
/* harmony import */ var _features_livestream_detail_const__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98346);






var VideoLoop = function(param) {
    var v = param.v, t = param.t, showBell = param.showBell;
    var images = v.images, live_title = v.name, id = v.id, viewer = v.viewer, live_streamer = v.live_streamer, start_datetime = v.start_datetime, duration = v.duration, status = v.status, city = v.city;
    var ref = live_streamer || {}, name = ref.name, avatar = ref.avatar;
    var handle = "".concat((0,_libs_app__WEBPACK_IMPORTED_MODULE_2__/* .createHandle */ .UR)(live_title), "-").concat(id);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
        className: "tw-w-full tw-z-0 tw-block tw-relative tw-border tw-rounded-5 tw-border-gray-31 hover:tw-border-primary-main tw-duration-500 tw-ease-linear",
        url: {
            pathname: _layouts_shared__WEBPACK_IMPORTED_MODULE_1__/* .PagePath.LiveVideoPage */ ._.LiveVideoPage,
            query: {
                id: handle
            }
        },
        children: [
            showBell && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .Ee, {
                alt: "bell",
                src: "/ico_bell.svg",
                className: "!tw-absolute tw--right-3 tw--top-4 tw-w-9 tw-h-9 tw-z-11"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "tw-w-full tw-relative tw-pb-55-percent tw-rounded-t-5 tw-overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .Ee, {
                        alt: name,
                        src: (0,_libs_app__WEBPACK_IMPORTED_MODULE_2__/* .getLiveVideoImage */ .eQ)(images),
                        className: "tw-w-full tw-h-full !tw-absolute tw-left-0 tw-top-0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-absolute tw-left-0 tw-top-0 tw-w-full tw-h-full tw-z-1",
                        style: {
                            background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 66.74%, #000000 151.27%)",
                            transform: "rotate(-180deg)"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-absolute tw-left-0 tw-top-0 tw-w-full tw-h-full tw-z-1",
                        style: {
                            background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 71.7%, #000000 113.56%)"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-z-11 tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-right-0 tw-text-white",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "tw-flex tw-flex-col tw-h-full tw-justify-between tw-p-2",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "tw-flex tw-gap-x-1 tw-items-center",
                                children: [
                                    status === _features_livestream_detail_const__WEBPACK_IMPORTED_MODULE_5__/* .LiveStreamStatus.LIVE_NOW */ .zN.LIVE_NOW && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "tw-flex tw-items-center tw-px-4 tw-bg-red-600 tw-text-white tw-font-xs tw-rounded tw-mr-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "tw-w-2 tw-h-2 tw-rounded-full tw-bg-white tw-mr-1 tw-block"
                                            }),
                                            "Live"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .ViewIcon */ .ON, {}),
                                        className: "tw-w-5 tw-h-5"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: " tw-text-sm",
                                        children: viewer
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-flex tw-flex-col tw-gap-y-1 tw-px-4 tw-py-4 tw-bg-white tw-rounded-b-5 tw-overflow-hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "tw-flex tw-gap-x-2 tw-items-center tw-text-secondary-70 tw-font-medium",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Avatar */ .qE, {
                            src: avatar,
                            className: "tw-w-6 tw-h-6",
                            rounded: "tw-rounded-full"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            dangerouslySetInnerHTML: {
                                __html: name
                            }
                        })
                    ]
                })
            })
        ]
    }, id);
};


/***/ }),

/***/ 34794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83554);
/* harmony import */ var _contexts_profile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48309);




var TitlePartial = function(param) {
    var name = param.name, className = param.className, cs = param.cs;
    var masterData = (0,_contexts_profile__WEBPACK_IMPORTED_MODULE_3__/* .useMasterData */ .AE)();
    var theme = (masterData !== null && masterData !== void 0 ? masterData : {}).theme;
    var icon_category_url = (theme !== null && theme !== void 0 ? theme : {}).icon_category_url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "_title tw-text-lg md:tw-text-2xl tw-flex tw-items-center tw-justify-center  tw-w-full  tw-relative ".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tw-flex tw-items-center tw-w-max tw-px-5 tw-justify-center ",
            children: [
                icon_category_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
                    src: icon_category_url,
                    alt: "star",
                    className: "tw-h-8 tw-w-8"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
                    src: "/diamond.svg",
                    alt: "star",
                    className: "tw-h-5 tw-w-5"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "tw-flex-1 tw-block tw-px-4 tw-uppercase tw-text-primary-main tw-font-semibold ".concat(cs),
                    children: name
                }),
                icon_category_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
                    src: icon_category_url,
                    alt: "star",
                    className: "tw-h-8 tw-w-8"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
                    src: "/diamond.svg",
                    alt: "star",
                    className: "tw-h-5 tw-w-5"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(TitlePartial));


/***/ }),

/***/ 98346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UC": function() { return /* binding */ PinnedProductDefault; },
/* harmony export */   "Ww": function() { return /* binding */ FormChatDefault; },
/* harmony export */   "i1": function() { return /* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_0__.i; },
/* harmony export */   "zN": function() { return /* binding */ LiveStreamStatus; }
/* harmony export */ });
/* harmony import */ var _models__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11444);


var LiveStreamStatus = {
    LIVE_NOW: "LIVE_NOW",
    UNPUBLISHED: "UNPUBLISHED",
    SCHEDULED_LIVE: "SCHEDULED_LIVE",
    SCHEDULED_CANCELED: "SCHEDULED_CANCELED",
    SCHEDULED_UNPUBLISHED: "SCHEDULED_UNPUBLISHED",
    VOD: "VOD",
    LIVE: "LIVE"
};
/**
 * Default !value
 */ var FormChatDefault = {
    comment: ""
};
var PinnedProductDefault = null;


/***/ }),

/***/ 89389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ detail; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/index.ts + 87 modules
var components = __webpack_require__(83554);
// EXTERNAL MODULE: ./features/livestream/shared.ts
var shared = __webpack_require__(83134);
// EXTERNAL MODULE: ./components/ui/Title/index.tsx
var Title = __webpack_require__(34794);
// EXTERNAL MODULE: ./features/livestream/detail/api.ts
var api = __webpack_require__(77910);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(74931);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 171 modules
var motion = __webpack_require__(15331);
// EXTERNAL MODULE: ./components/loop/VideoLoop.tsx
var VideoLoop = __webpack_require__(30161);
;// CONCATENATED MODULE: ./features/livestream/detail/partials/list/index.tsx









var ListPartial = function(param) {
    var t = param.t;
    var ref = (0,react.useState)(shared/* LiveVideosDefault */.y), liveVideosCursor = ref[0], setLiveVideosCursor = ref[1];
    var ref1 = (0,api/* useFetchLiveVideosQuery */.fN)({
        limit: 4,
        offset: 0
    }, {
        enabled: false,
        retry: false,
        refetchOnWindowFocus: false,
        onError: function(data) {
            react_hot_toast_esm/* default.error */.ZP.error(data.message);
        },
        onSuccess: function(param) {
            var data = param.data, totalRecords = param.total_records;
            var edges = Array.isArray(data) ? data : [];
            setLiveVideosCursor({
                edges: edges,
                count: +totalRecords
            });
        }
    }), refetch = ref1.refetch, isLoading = ref1.isLoading;
    (0,react.useEffect)(function() {
        refetch();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                name: t("detail.list-live-title"),
                className: "_title-live-detail"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex tw-flex-col tw-mt-10",
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-h-10 tw-flex tw-justify-center tw-items-center tw-text-primary-main",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LoadingSpin64 */.h, {})
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                    initial: "mainInitial",
                    animate: "mainAnimate",
                    exit: "mainExit",
                    variants: {
                        mainInitial: {
                            opacity: 0
                        },
                        mainAnimate: {
                            opacity: 1,
                            transition: {
                                duration: 0.4
                            }
                        },
                        mainExit: {
                            opacity: 0
                        }
                    },
                    children: !!liveVideosCursor.edges && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-grid tw-grid-col-2 md:tw-grid-cols-4 tw-gap-2 md:tw-gap-4",
                        children: liveVideosCursor.edges.map(function(v) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoLoop/* VideoLoop */.W, {
                                v: v,
                                t: t
                            }, v.id);
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var list = (/*#__PURE__*/(0,react.memo)(ListPartial));

// EXTERNAL MODULE: ./features/livestream/detail/const.ts
var detail_const = __webpack_require__(98346);
// EXTERNAL MODULE: ./layouts/shared.ts
var layouts_shared = __webpack_require__(7806);
// EXTERNAL MODULE: ./contexts/profile/index.tsx
var contexts_profile = __webpack_require__(48309);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./features/livestream/detail/util.ts
var productsRangeBuilder = function(products) {
    if (!Array.isArray(products)) {
        return [];
    }
    var arr = [];
    var p = products.sort(function(a, b) {
        return a.played - b.played;
    });
    for(var i = 0; i < p.length; i++){
        var ref = p[i + 1] || {}, nextRangeStartSecond = ref.played;
        var _i = p[i], rangeStartSecond = _i.played;
        var rangeEndSecond = 86400;
        if (nextRangeStartSecond) {
            rangeEndSecond = nextRangeStartSecond;
        }
        arr.push({
            product: p[i],
            range: [
                rangeStartSecond,
                rangeEndSecond
            ]
        });
    }
    return arr;
};
var getCommentAuthor = function(user, staff) {
    if (!user && !staff) return {
        avatar: "/logo-mini.jpeg",
        fullname: "#"
    };
    var author = user || staff;
    if (author) {
        var avatar = author.avatar, fullname = author.fullname;
        return {
            avatar: avatar,
            fullname: fullname
        };
    }
    return {
        avatar: "",
        fullname: "#"
    };
};

// EXTERNAL MODULE: ./libs/dayjs/index.ts
var dayjs = __webpack_require__(74865);
;// CONCATENATED MODULE: ./features/livestream/detail/partials/chat/Comments/ReplyComment.tsx





var ReplyComment = function(props) {
    var ref, ref1;
    var replyComment = props.replyComment, fullName = props.fullName;
    var _user = (replyComment === null || replyComment === void 0 ? void 0 : replyComment.facebook_comment_info) ? {
        fullname: (replyComment === null || replyComment === void 0 ? void 0 : (ref = replyComment.facebook_comment_info) === null || ref === void 0 ? void 0 : ref.facebook_user.first_name) || "",
        avatar: (replyComment === null || replyComment === void 0 ? void 0 : (ref1 = replyComment.facebook_comment_info) === null || ref1 === void 0 ? void 0 : ref1.facebook_user.avatar_url) || ""
    } : null;
    var ref2 = getCommentAuthor(_user ? _user : null, (replyComment === null || replyComment === void 0 ? void 0 : replyComment.staffs) ? replyComment === null || replyComment === void 0 ? void 0 : replyComment.staffs : null), replyName = ref2.fullname, avatar = ref2.avatar;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-gap-x-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Avatar */.qE, {
                alt: replyName,
                src: avatar || "",
                className: "tw-w-5 tw-h-5",
                rounded: "tw-rounded-full"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-bg-white tw-px-4 tw-py-1 tw-rounded-b-lg tw-rounded-lg tw-relative tw-flex-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        dangerouslySetInnerHTML: {
                            __html: replyName
                        },
                        className: "text-user-chat tw-font-normal tw-text-13 tw-line-clamp-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "tw-text-secondary-70 tw-text-13",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: fullName
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: (replyComment === null || replyComment === void 0 ? void 0 : replyComment.comment) || ""
                                }
                            })
                        ]
                    }),
                    (replyComment === null || replyComment === void 0 ? void 0 : replyComment.updated_at) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-text-right tw-text-secondary-50",
                        style: {
                            fontSize: "10px"
                        },
                        children: (0,dayjs/* humanTimeDate */.EM)(replyComment === null || replyComment === void 0 ? void 0 : replyComment.updated_at)
                    })
                ]
            })
        ]
    }, "reply-comment-" + (replyComment === null || replyComment === void 0 ? void 0 : replyComment.id));
};

// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(65820);
// EXTERNAL MODULE: ./libs/app/index.ts
var app = __webpack_require__(92517);
// EXTERNAL MODULE: ./features/products/detail/api.ts
var detail_api = __webpack_require__(17852);
// EXTERNAL MODULE: ./features/consults/chat/api.ts
var chat_api = __webpack_require__(96732);
;// CONCATENATED MODULE: ./features/livestream/detail/partials/chat/Comments/Products.tsx









var Products = function(param) {
    var onClose = param.onClose, liveId = param.liveId, t = param.t, userId = param.userId, sendComment = param.sendComment;
    var ref = (0,react.useState)([]), products = ref[0], setProducts = ref[1];
    var ref1 = (0,react.useState)(), p = ref1[0], setP = ref1[1];
    var refetch = (0,api/* useFetchProductLiveIdQuery */.Ov)(liveId, {
        onSuccess: function(param) {
            var data = param.data;
            setProducts(data);
        }
    }).refetch;
    var ref2 = (0,chat_api/* useCreateOrderChat */.qW)({}), sendMessage = ref2.mutate;
    var ref3 = (0,detail_api/* useFetchConversationByProductQuery */.uK)((p === null || p === void 0 ? void 0 : p.id) || 0, {
        retry: 0,
        enabled: false,
        onSuccess: function(data) {
            var ref = data.data || {}, id = ref.id, type_code = ref.type_code, type = ref.type;
            sendMessage({
                id: id,
                data: {
                    content: "TV ".concat(type_code),
                    images: [],
                    type: "text"
                }
            });
        },
        onError: function() {
            return mutate({
                title: (p === null || p === void 0 ? void 0 : p.product_name) || "",
                type_id: (p === null || p === void 0 ? void 0 : p.id) || 0,
                type_image: (0,app/* getProductImage */.C6)(p === null || p === void 0 ? void 0 : p.images) || "",
                type_code: (p === null || p === void 0 ? void 0 : p.product_code) || "",
                type: detail_const/* ConversationType.Product */.i1.Product
            });
        }
    }), fetchConversation = ref3.refetch, isFetchConversationLoading = ref3.isLoading;
    var ref4 = (0,api/* useCreateChatConversation */.uJ)({
        onSuccess: function(param) {
            var data = param.data;
            var conversation = data.conversation;
            sendMessage({
                id: conversation.id,
                data: {
                    content: "TV ".concat(conversation.type_code),
                    images: [],
                    type: "text"
                }
            });
        },
        onError: function(param) {
            var message = param.message;
        }
    }), mutate = ref4.mutate, isCreateChatConversationLoading = ref4.isLoading;
    var onConsultClick = function(p) {
        if (p.id) {
            setP(p);
        }
    };
    (0,react.useEffect)(function() {
        if (p === null || p === void 0 ? void 0 : p.id) fetchConversation();
    }, [
        fetchConversation,
        p === null || p === void 0 ? void 0 : p.id
    ]);
    (0,react.useEffect)(function() {
        refetch();
    }, [
        liveId,
        refetch
    ]);
    var handleSendMessage = function(p) {
        onConsultClick(p);
        sendComment(p.product_code);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-relative tw-w-full tw-h-full tw-flex tw-flex-col tw-rounded-lg tw-bg-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-px-3 tw-py-1 tw-border-b tw-items-center tw-justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-text-base tw-font-semibold",
                        children: "Sản phẩm trong Livestream"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-cursor-pointer",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* XNewIcon */.HW, {}),
                            className: "tw-w-6 tw-h-6"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-mt-2 tw-overflow-y-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " tw-flex tw-flex-col tw-h-full",
                    children: products.length > 0 ? products.map(function(p, i) {
                        var ref, ref1, ref2, ref3, ref4;
                        var isDiscount = p.product_discount ? (0,app/* checkTime */.s)((ref = p.product_discount) === null || ref === void 0 ? void 0 : ref.started_at, (ref1 = p.product_discount) === null || ref1 === void 0 ? void 0 : ref1.ended_at) : false;
                        if ((p === null || p === void 0 ? void 0 : p.product_discount) && ((ref2 = p.product_discount) === null || ref2 === void 0 ? void 0 : ref2.status) === layouts_shared/* DiscountStatus.Ended */.YT.Ended) isDiscount = false;
                        var isDeposited = p.quantity <= 0 || p.status == layouts_shared/* ProductStatus.CloseASale */.Pt.CloseASale || p.status === layouts_shared/* ProductStatus.Deposited */.Pt.Deposited;
                        var handle = "".concat((0,app/* createHandle */.UR)(p.product_name), "-").concat(p.id, "-").concat(p.product_code);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex tw-gap-2 tw-p-2 ".concat(i < products.length && "tw-border-b"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-w-[54px] tw-h-[54px] tw-relative tw-leading-0 tw-bg-secondary-20 tw-z-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                className: "tw-w-full tw-h-full !tw-absolute tw-z-1 tw-top-0 tw-left-0 tw-bottom-0",
                                                alt: p.product_name,
                                                src: p.images && p.images[0] ? p.images[0].url : "/bg-default.png"
                                            }),
                                            p.product_discount && isDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tw-w-4 tw-h-4 tw-absolute tw-top-1 tw-right-1 tw-z-10",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                        src: "/sale.png",
                                                        className: "tw-w-full tw-h-full",
                                                        alt: "sale"
                                                    })
                                                })
                                            }),
                                            p.is_auction && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tw-w-4 tw-h-4 tw-absolute tw-top-1 tw-right-1 tw-z-10",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                        src: "/auction.png",
                                                        className: "tw-w-full tw-h-full",
                                                        alt: "auction"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-flex tw-flex-col tw-flex-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                                url: {
                                                    pathname: layouts_shared/* PagePath.ProductDetailPage */._.ProductDetailPage,
                                                    query: {
                                                        id: handle
                                                    }
                                                },
                                                target: "_black",
                                                className: "tw-line-clamp-1 tw-text-primary-main tw-text-xs tw-leading-4 tw-font-bold",
                                                children: p === null || p === void 0 ? void 0 : p.product_name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "",
                                                children: !p.quotation ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "tw-text-secondary-70 tw-flex tw-flex-col",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "tw-text-xs",
                                                            children: p.product_code
                                                        }),
                                                        p.product_discount && isDiscount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "tw-flex",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "tw-text-warning-90 tw-font-medium tw-text-13",
                                                                    children: (0,app/* toMoney */.KP)(p.price - p.price * ((ref3 = p.product_discount) === null || ref3 === void 0 ? void 0 : ref3.discount) / 100, t)
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "\xa0~\xa0"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "tw-text-primary-main tw-font-medium tw-text-13",
                                                                    children: (0,app/* toMoney */.KP)(p.token - p.token * ((ref4 = p.product_discount) === null || ref4 === void 0 ? void 0 : ref4.discount) / 100, t, layouts_shared/* PriceSymbol.Atd */.hb.Atd)
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "tw-flex tw-text-xs tw-items-center lg:tw-gap-x-1",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "tw-text-warning-90 tw-font-medium tw-text-xs",
                                                                    children: (0,app/* toMoney */.KP)(p.price, t)
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "\xa0~\xa0"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "tw-text-primary-main tw-font-medium tw-text-xs",
                                                                    children: (0,app/* toMoney */.KP)(p.token, t, layouts_shared/* PriceSymbol.Atd */.hb.Atd)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "tw-text-secondary-70",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "tw-text-xs",
                                                                children: p.product_code
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "tw-text-warning-90",
                                                                children: t("layout:btn.contact")
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-flex tw-items-center tw-justify-center tw-flex-col tw-gap-y-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Button */.zx, {
                                                disabled: !userId || p.quantity <= 0,
                                                onClick: function() {
                                                    return handleSendMessage(p);
                                                },
                                                className: "!tw-flex tw-items-center tw-justify-center !tw-w-max lg:!tw-w-[125px] tw-text-xs !tw-rounded-5 tw-py-1 tw-px-3 sm:tw-w-1/2 tw-h-[34px]",
                                                variant: components/* ButtonVariant.Outlined */.Wu.Outlined,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ChatLineIcon */.Ce, {}),
                                                        className: "tw-w-3 tw-h-3 tw-mr-3 lg:tw-mr-2 xl:tw-mr-3"
                                                    }),
                                                    t("layout:btn.consult")
                                                ]
                                            }),
                                            !p.is_auction && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: p.quotation ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "tw-w-full tw-flex tw-justify-start tw-mt-6",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                                            disabled: p.status !== layouts_shared/* ProductStatus.Availability */.Pt.Availability,
                                                            onClick: function() {
                                                                return onConsultClick(p);
                                                            },
                                                            className: "tw-flex tw-items-center tw-justify-center !tw-w-max lg:!tw-w-[125px] tw-text-xs !tw-rounded-5 tw-py-1 tw-px-3 sm:tw-w-1/2 tw-text-warning-90 tw-border-warning-90 tw-h-[34px]",
                                                            variant: components/* ButtonVariant.Outlined */.Wu.Outlined,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "tw-flex tw-gap-x-4 tw-justify-center",
                                                                children: "Li\xean hệ"
                                                            })
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: p.quantity <= 0 || p.status != layouts_shared/* ProductStatus.Availability */.Pt.Availability ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Button */.zx, {
                                                        disabled: true,
                                                        className: "!tw-rounded-5 tw-text-white tw-bg-primary-main tw-py-1 tw-px-3 tw-flex tw-items-center tw-justify-center !tw-w-max lg:!tw-w-[125px] tw-uppercase tw-text-xs",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* WalletIcon */.o, {}),
                                                                className: "tw-w-3 tw-h-3 tw-mr-1 tw-text-white"
                                                            }),
                                                            t("layout:btn.deposited")
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Link */.rU, {
                                                        url: {
                                                            pathname: layouts_shared/* PagePath.ProductDepositPage */._.ProductDepositPage,
                                                            query: {
                                                                id: p.id,
                                                                stream_id: liveId
                                                            }
                                                        },
                                                        target: "_blank",
                                                        className: "tw-bg-primary-main !tw-text-white !tw-w-max lg:!tw-w-[125px] tw-gap-x-1 tw-border tw-px-3 tw-py-1 tw-rounded-5 tw-flex tw-items-center tw-justify-center tw-uppercase tw-text-xs ",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* WalletIcon */.o, {}),
                                                                className: "tw-w-3 tw-h-3 tw-mr-1 tw-text-white"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: t("layout:btn.order")
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        });
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-py-10 tw-text-lg tw-text-center",
                        children: "Kh\xf4ng c\xf3 sản phẩm"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Comments_Products = (Products);

;// CONCATENATED MODULE: ./features/livestream/detail/partials/chat/Comments/index.tsx



















// eslint-disable-next-line react/display-name
var CommentPartial = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var liveId = param.liveId, isAuth = param.isAuth, messageData = param.messageData, commentList = param.commentList, defaultOffset = param.defaultOffset, isShowProducts = param.isShowProducts, hiddenProducts = param.hiddenProducts, t = param.t, sendComment = param.sendComment;
    var _$ref, _$ref1, _$ref2, _$ref3;
    var profile = (0,contexts_profile/* useProfile */.Un)();
    var userId = (profile === null || profile === void 0 ? void 0 : profile.id) || null;
    var _$ref4 = (0,react.useState)(0), offset = _$ref4[0], setOffset = _$ref4[1];
    var _$ref5 = (0,react.useState)(commentList), comments = _$ref5[0], setComments = _$ref5[1];
    var _$ref6 = (0,react.useState)(""), selected = _$ref6[0], setSelected = _$ref6[1];
    var router = (0,next_router.useRouter)();
    var filterCommentOption = [
        {
            label: "Ph\xf9 hợp nhất",
            value: "my"
        },
        {
            label: "Xem tất cả",
            value: "all"
        }, 
    ];
    var commentEl = (0,react.useRef)(null);
    var _$ref7 = (0,api/* useFetchCommentsQuery */.iq)({
        id: +liveId,
        offset: offset
    }, {
        enabled: false,
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data;
            var _comments = Array.isArray(data) ? data : [];
            // setComments(comments.sort((a, b) => a.id - b.id));
            _comments.forEach(function(comment) {
                setComments(function(prev) {
                    if (!prev.find(function(p) {
                        return p.id === comment.id;
                    })) return (0,_to_consumable_array/* default */.Z)(prev).concat([
                        comment
                    ]);
                    else return (0,_to_consumable_array/* default */.Z)(prev);
                });
            });
        }
    }), refetchComments = _$ref7.refetch, isLoadingComments = _$ref7.isLoading;
    var _$ref8 = (0,api/* useFetchCommentsQuery */.iq)({
        id: +liveId,
        offset: 0
    }, {
        enabled: false,
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data;
            var comments = Array.isArray(data) ? data : [];
            // setComments(comments.sort((a, b) => a.id - b.id));
            setComments(comments);
        }
    }), refetchFirstComments = _$ref8.refetch;
    var _$ref9 = (0,api/* useFetchCommentByIdQuery */.aH)(((_$ref = router.query) === null || _$ref === void 0 ? void 0 : _$ref.comment_id) ? +((_$ref1 = router.query) === null || _$ref1 === void 0 ? void 0 : _$ref1.comment_id) : 0, {
        enabled: false,
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data;
            if (typeof data == "object") setComments([
                data
            ]);
        // setComments((prev) => prev.concat(comments));
        }
    }), refetchComment = _$ref9.refetch;
    var scrollToBottom = function() {
        var parent = document.getElementById("scrollableDiv");
        if (parent && commentEl && comments.length) {
            parent.scrollTop = commentEl.current.scrollHeight;
        }
    };
    var loadFunc = function() {
        setOffset(function(prev) {
            return prev + 20;
        });
    };
    var removeEventLottery = function() {
        setTimeout(function() {
            setComments(function(prev) {
                var arr = prev.filter(function(c) {
                    return c.type !== "lottery";
                });
                return (0,_to_consumable_array/* default */.Z)(arr);
            });
        }, 10000);
    };
    var handleSelect = function(data) {
        setSelected(data.value);
        if (!isAuth) return;
        scrollToBottom();
        setOffset(0);
        if (data.value === filterCommentOption[0].value) refetchComment();
        else {
            refetchFirstComments();
        }
    };
    (0,react.useEffect)(function() {
        setComments(commentList);
    }, [
        commentList
    ]);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            scrollToBottom: function() {
                scrollToBottom();
            }
        };
    });
    (0,react.useEffect)(function() {
        var _$ref;
        scrollToBottom();
        setOffset(defaultOffset);
        if ((_$ref = router.query) === null || _$ref === void 0 ? void 0 : _$ref.comment_id) {
            setSelected(filterCommentOption[0].value);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        liveId,
        defaultOffset,
        (_$ref2 = router.query) === null || _$ref2 === void 0 ? void 0 : _$ref2.comment_id
    ]);
    (0,react.useEffect)(function() {
        if (!messageData) return;
        if (messageData.method === layouts_shared/* CommentMethod.CreateComment */.iz.CreateComment || messageData.method === layouts_shared/* CommentMethod.UnHideComment */.iz.UnHideComment) {
            if (!messageData.data.comment) return;
            scrollToBottom();
            return setComments(function(prev) {
                return [
                    messageData === null || messageData === void 0 ? void 0 : messageData.data
                ].concat((0,_to_consumable_array/* default */.Z)(prev));
            });
        }
        if (messageData.method === layouts_shared/* CommentMethod.DeleteComment */.iz.DeleteComment || messageData.method === layouts_shared/* CommentMethod.HideComment */.iz.HideComment) {
            scrollToBottom();
            setComments(function(prev) {
                var _c = prev.filter(function(v) {
                    return v.id !== (messageData === null || messageData === void 0 ? void 0 : messageData.data.comment_id);
                });
                return _c;
            });
        }
        if (messageData.method === layouts_shared/* CommentMethod.CreateReplyComment */.iz.CreateReplyComment || messageData.method === layouts_shared/* CommentMethod.UnHideReplyComment */.iz.UnHideReplyComment) {
            setComments(function(prev) {
                var _c = (0,lodash.forEach)(prev, function(m) {
                    if (m.id === messageData.data.parent_id) {
                        m.reply_comments ? m.reply_comments.push(messageData === null || messageData === void 0 ? void 0 : messageData.data) : m.reply_comments = [
                            messageData === null || messageData === void 0 ? void 0 : messageData.data
                        ];
                    }
                });
                return _c;
            });
        }
        if (messageData.method === layouts_shared/* CommentMethod.DeleteReplyComment */.iz.DeleteReplyComment || messageData.method === layouts_shared/* CommentMethod.HideReplyComment */.iz.HideReplyComment) {
            setComments(function(prev) {
                var _c = (0,lodash.forEach)(prev, function(m) {
                    if (m.id === messageData.data.comment_id) {
                        var _$ref;
                        m.reply_comments = m === null || m === void 0 ? void 0 : (_$ref = m.reply_comments) === null || _$ref === void 0 ? void 0 : _$ref.filter(function(c) {
                            return c.id !== messageData.data.reply_comment_id;
                        });
                    }
                });
                return _c;
            });
        }
        if (messageData.method === layouts_shared/* CommentMethod.UpdateComment */.iz.UpdateComment) {
            setComments(function(prev) {
                var _c = (0,lodash.forEach)(prev, function(m) {
                    if (m.id === messageData.data.id) {
                        m.comment = messageData.data.comment;
                    }
                });
                return _c;
            });
        }
        if (messageData.method === layouts_shared/* CommentMethod.UpdateReplyComment */.iz.UpdateReplyComment) {
            setComments(function(prev) {
                var _c = (0,lodash.forEach)(prev, function(m) {
                    if (m.id === messageData.data.parent_id) {
                        var _$ref;
                        var c = m === null || m === void 0 ? void 0 : (_$ref = m.reply_comments) === null || _$ref === void 0 ? void 0 : _$ref.find(function(c) {
                            return c.id === messageData.data.id;
                        });
                        if (c) c.comment = messageData.data.comment;
                    }
                });
                return _c;
            });
        }
        if (messageData.method === layouts_shared/* LotterySocketMethod.OpenLottery */.Sf.OpenLottery) {
            setComments(function(prev) {
                var _m = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, messageData.data), {
                    comment: "Bắt đầu xổ số",
                    type: "lottery"
                });
                return [
                    _m
                ].concat((0,_to_consumable_array/* default */.Z)(prev));
            });
        }
        if (messageData.method === layouts_shared/* LotterySocketMethod.EndLottery */.Sf.EndLottery) {
            setComments(function(prev) {
                var _m = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, messageData.data), {
                    comment: "Kết th\xfac xổ số",
                    type: "lottery"
                });
                return [
                    _m
                ].concat((0,_to_consumable_array/* default */.Z)(prev));
            });
            removeEventLottery();
        }
        if (messageData.method === layouts_shared/* LotterySocketMethod.CloseListLottery */.Sf.CloseListLottery) {
            setComments(function(prev) {
                var _m = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, messageData.data), {
                    comment: "Chốt danh s\xe1ch xổ số",
                    type: "lottery"
                });
                return [
                    _m
                ].concat((0,_to_consumable_array/* default */.Z)(prev));
            });
        }
        if (messageData.method === layouts_shared/* LotterySocketMethod.AdminPickTicketLottery */.Sf.AdminPickTicketLottery) {
            setComments(function(prev) {
                var _m = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, messageData.data), {
                    comment: "Kết quả sổ số: " + messageData.data.number,
                    type: "lottery"
                });
                return [
                    _m
                ].concat((0,_to_consumable_array/* default */.Z)(prev));
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        messageData,
        messageData === null || messageData === void 0 ? void 0 : messageData.data.id
    ]);
    (0,react.useEffect)(function() {
        if (!isAuth) return;
        if (!isLoadingComments && offset && selected !== filterCommentOption[0].value) {
            refetchComments();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        offset,
        isLoadingComments,
        isAuth,
        selected
    ]);
    var getCommentUser = function(comment) {
        var users = comment.users, facebook_comment_info = comment.facebook_comment_info, youtube_comment_info = comment.youtube_comment_info, tiktok_comment_info = comment.tiktok_comment_info;
        if (users) {
            return users;
        }
        if (facebook_comment_info) {
            return {
                fullname: (facebook_comment_info === null || facebook_comment_info === void 0 ? void 0 : facebook_comment_info.facebook_user.first_name) || "",
                avatar: (facebook_comment_info === null || facebook_comment_info === void 0 ? void 0 : facebook_comment_info.facebook_user.avatar_url) || ""
            };
        }
        if (youtube_comment_info) {
            return {
                fullname: (youtube_comment_info === null || youtube_comment_info === void 0 ? void 0 : youtube_comment_info.youtube_user.first_name) || "",
                avatar: (youtube_comment_info === null || youtube_comment_info === void 0 ? void 0 : youtube_comment_info.youtube_user.avatar_url) || ""
            };
        }
        if (tiktok_comment_info) {
            return {
                fullname: (tiktok_comment_info === null || tiktok_comment_info === void 0 ? void 0 : tiktok_comment_info.tiktok_user.first_name) || "",
                avatar: (tiktok_comment_info === null || tiktok_comment_info === void 0 ? void 0 : tiktok_comment_info.tiktok_user.avatar_url) || ""
            };
        }
        return null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            ((_$ref3 = router.query) === null || _$ref3 === void 0 ? void 0 : _$ref3.comment_id) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-w-max tw-z-10 tw-bg-muted-90",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SelectCustom */.uU, {
                    className: "tw-h-7 tw-text-xs !tw-px-2 !tw-w-40",
                    options: filterCommentOption,
                    handleSelect: handleSelect
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-relative tw-w-full tw-flex-1 tw-overflow-hidden tw-block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "scrollableDiv",
                        className: "tw-relative",
                        style: {
                            overflow: "auto",
                            display: "flex",
                            flexDirection: "column-reverse",
                            height: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                            dataLength: comments.length,
                            next: loadFunc,
                            style: {
                                display: "flex",
                                height: "100%",
                                flexDirection: "column-reverse"
                            },
                            inverse: true,
                            hasMore: true,
                            loader: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            // className="tw-gap-y-4"
                            scrollableTarget: "scrollableDiv",
                            ref: commentEl,
                            children: comments.map(function(item) {
                                var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5;
                                var comment = item.comment, id = item.id, staffs = item.staffs, type = item.type, reply_comments = item.reply_comments, facebook_comment_info = item.facebook_comment_info, youtube_comment_info = item.youtube_comment_info, tiktok_comment_info = item.tiktok_comment_info, created_at = item.created_at;
                                var _user = getCommentUser(item);
                                var replyComments = Array.from(new Set(reply_comments)).length > 0 ? reply_comments === null || reply_comments === void 0 ? void 0 : reply_comments.sort(function(a, b) {
                                    return a && new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime();
                                }) : [];
                                var _$ref6 = getCommentAuthor(_user, staffs ? staffs : null), fullName = _$ref6.fullname, avatar = _$ref6.avatar;
                                if (!comment) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                if (type === "lottery") return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-flex tw-justify-center tw-mt-4",
                                    children: item.number ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "tw-text-secondary-91 tw-flex tw-items-center tw-text-13 tw-py-2 tw-px-9 tw-rounded-2xl",
                                            style: {
                                                background: "rgba(0, 0, 0, 0.06)"
                                            },
                                            children: [
                                                comment,
                                                [
                                                    1,
                                                    2,
                                                    3
                                                ].map(function(i) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                        src: "/confetti-flat.gif",
                                                        alt: "confetti",
                                                        className: "tw-w-6 tw-h-6 ".concat(i == 1 && " tw-ml-1")
                                                    }, "i-".concat(1));
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-text-secondary-91 tw-text-13 tw-py-2 tw-px-9 tw-rounded-2xl",
                                                style: {
                                                    background: "rgba(0, 0, 0, 0.06)"
                                                },
                                                children: comment
                                            })
                                        ]
                                    })
                                }, comment + "-" + new Date().getTime());
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-flex tw-gap-x-2 tw-w-full tw-mt-4 tw-items-end",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Avatar */.qE, {
                                                    alt: fullName,
                                                    src: avatar || "",
                                                    className: "tw-w-8 tw-h-8 tw-mt-6",
                                                    rounded: "tw-rounded-full"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tw-flex-1",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "tw-w-full",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "tw-bg-white tw-px-4 tw-py-1 tw-rounded-t-lg tw-rounded-br-lg tw-relative custom-polygon-bottom",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "text-user-chat tw-font-bold tw-text-13 tw-flex tw-items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            dangerouslySetInnerHTML: {
                                                                                __html: item.comment_attachments && item.comment_attachments.length > 0 && ((_$ref = item.comment_attachments[0]) === null || _$ref === void 0 ? void 0 : _$ref.type) == "AUCTION_TOP_OFFER_HIGHEST_PRICE" ? "Hệ thống" : fullName
                                                                            }
                                                                        }),
                                                                        !!facebook_comment_info && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                                            className: "tw-w-3 tw-h-3 tw-ml-2",
                                                                            src: "/fb-mini.png",
                                                                            alt: "fb-min"
                                                                        }),
                                                                        !!youtube_comment_info && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                                            className: "tw-w-3 tw-h-3 tw-ml-2",
                                                                            src: "/youtube-mini.png",
                                                                            alt: "ytb-min"
                                                                        }),
                                                                        !!tiktok_comment_info && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                                            className: "tw-w-3 tw-h-3 tw-ml-2",
                                                                            src: "/tiktok-mini.webp",
                                                                            alt: "ttk-min"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "tw-text-secondary-70 tw-text-13 tw-font-normal",
                                                                    children: comment
                                                                }),
                                                                item.comment_attachments && item.comment_attachments.length > 0 && ((_$ref1 = item.comment_attachments[0]) === null || _$ref1 === void 0 ? void 0 : _$ref1.type) === "AUCTION_TOP_OFFER_HIGHEST_PRICE" && ((_$ref2 = item.comment_attachments[0]) === null || _$ref2 === void 0 ? void 0 : (_$ref3 = _$ref2.data) === null || _$ref3 === void 0 ? void 0 : _$ref3.user_auction) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "tw-py-2 tw-text-13 tw-w-full tw-bg-white tw-rounded tw-mx-auto",
                                                                    style: {
                                                                        minWidth: 350
                                                                    },
                                                                    children: (_$ref4 = item.comment_attachments[0]) === null || _$ref4 === void 0 ? void 0 : (_$ref5 = _$ref4.data) === null || _$ref5 === void 0 ? void 0 : _$ref5.user_auction.sort(function(a, b) {
                                                                        return b.price - a.price;
                                                                    }).slice(0, 3).map(function(u, i) {
                                                                        var _$ref, _$ref1, _$ref2, _$ref3;
                                                                        var name = u.type === "FACEBOOK" ? (_$ref = u.facebook_user) === null || _$ref === void 0 ? void 0 : _$ref.first_name : (_$ref1 = u.users) === null || _$ref1 === void 0 ? void 0 : _$ref1.fullname;
                                                                        var avatar = u.type === "FACEBOOK" ? (_$ref2 = u.facebook_user) === null || _$ref2 === void 0 ? void 0 : _$ref2.avatar_url : (_$ref3 = u.users) === null || _$ref3 === void 0 ? void 0 : _$ref3.avatar;
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "tw-flex tw-items-center tw-py-1 tw-gap-1 tw-text-[11px]",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    children: [
                                                                                        i + 1,
                                                                                        "."
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Avatar */.qE, {
                                                                                    alt: name,
                                                                                    src: avatar || "",
                                                                                    className: "tw-w-5 tw-h-5 tw-mx-1",
                                                                                    rounded: "tw-rounded-full"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    children: name
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    children: "-"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "tw-font-bold",
                                                                                    children: (0,app/* toMoney */.KP)(u.price, t, layouts_shared/* PriceSymbol.$ */.hb.$)
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    children: "/"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "tw-text-secondary-50",
                                                                                            children: "Thời gian:"
                                                                                        }),
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                                            children: u.created_at ? (0,dayjs/* formatTimeHMSS */.i5)(u.created_at) : "--:--:--"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }, "top-auction-".concat(name, "-").concat(u.price));
                                                                    })
                                                                }),
                                                                created_at && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "tw-text-right tw-text-secondary-50",
                                                                    style: {
                                                                        fontSize: "10px"
                                                                    },
                                                                    children: (0,dayjs/* humanTimeDate */.EM)(created_at)
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tw-w-9"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tw-flex-1",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "tw-w-3/4",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: replyComments && (replyComments === null || replyComments === void 0 ? void 0 : replyComments.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "tw-flex tw-flex-col tw-mt-2 tw-gap-y-2",
                                                                    children: replyComments === null || replyComments === void 0 ? void 0 : replyComments.map(function(rC) {
                                                                        return rC && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReplyComment, {
                                                                            fullName: fullName,
                                                                            replyComment: rC
                                                                        }, "rep-".concat(id, "-").concat(rC === null || rC === void 0 ? void 0 : rC.id));
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, "comment-" + id + "-" + created_at);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                        children: isShowProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                            initial: {
                                height: 0,
                                opacity: 0
                            },
                            animate: {
                                height: "100%",
                                opacity: 1
                            },
                            exit: {
                                height: 0,
                                opacity: 0
                            },
                            transition: {
                                duration: 0.5
                            },
                            className: "tw-absolute tw-bottom-0 tw-left-0 tw-bg-transparent tw-h-full tw-w-full tw-rounded-lg tw-max-h-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Comments_Products, {
                                userId: userId,
                                sendComment: sendComment,
                                onClose: hiddenProducts,
                                liveId: liveId,
                                t: t
                            })
                        })
                    })
                ]
            })
        ]
    });
});
/* harmony default export */ var Comments = (CommentPartial);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(95496);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./features/livestream/detail/partials/chat/SendSticker/index.tsx








var SendSticker = function(param) {
    var collectionStickers = param.collectionStickers, sendSticker = param.sendSticker, t = param.t, giftAtd = param.giftAtd, isLoading = param.isLoading;
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)(collectionStickers[0].name), collection = ref3[0], setCollection = ref3[1];
    var ref4 = (0,react.useState)([]), listSticker = ref4[0], setListSticker = ref4[1];
    var masterData = (0,contexts_profile/* useMasterData */.AE)();
    var ref5 = (0,react.useState)(), sticker = ref5[0], setSticker = ref5[1];
    var ref6 = (0,react.useState)(0), atd = ref6[0], setAtd = ref6[1];
    var ref7 = (0,api/* useStickerQuery */.g)({
        collection: collection != "send-atd" ? collection : collectionStickers[0].name,
        offset: 0,
        limit: 100
    }, {
        enabled: false,
        refetchOnWindowFocus: false,
        onSuccess: function(data) {
            console.log(data);
            setListSticker(data.data);
        }
    }), refetchSticker = ref7.refetch, isLoadingStickers = ref7.isLoading;
    var chooseSticker = (0,react.useCallback)(function() {
        var ref;
        if (atd && collection === "send-atd") return giftAtd(atd);
        var collectionStickerId = (ref = collectionStickers.find(function(c) {
            return c.name === collection;
        })) === null || ref === void 0 ? void 0 : ref.id;
        if (sticker && collectionStickerId) {
            var _s = {
                id: sticker.id,
                icon: sticker.icon,
                name: sticker.name,
                collection_id: collectionStickerId
            };
            return sendSticker(_s);
        }
    }, [
        atd,
        collection,
        giftAtd,
        sendSticker,
        sticker,
        collectionStickers
    ]);
    (0,react.useEffect)(function() {
        if (collection != "send-atd") refetchSticker();
    }, [
        collection,
        refetchSticker
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-px-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-w-11/12 tw-overflow-x-auto",
                        children: [
                            collectionStickers.map(function(c) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-pr-6 tw-text-secondary-70 tw-cursor-pointer ".concat(collection === c.name ? "tw-font-semibold" : ""),
                                    onClick: function() {
                                        return setCollection(c.name);
                                    },
                                    children: c.name
                                }, "sticker-" + c.id);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-pr-6 tw-text-secondary-70 tw-cursor-pointer ".concat(collection === "send-atd" ? "tw-font-semibold" : ""),
                                onClick: function() {
                                    return setCollection("send-atd");
                                },
                                children: masterData === null || masterData === void 0 ? void 0 : (ref = masterData.live_stream_gift_atd) === null || ref === void 0 ? void 0 : ref.title
                            }, "send-atd")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-h-28 tw-mt-4 tw-leading-0 tw-justify-start tw-items-start tw-overflow-y-auto tw-flex tw-flex-wrap tw-relative ",
                        children: isLoadingStickers ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-col-span-5 tw-flex tw-items-center tw-justify-center tw-w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Loading */.gb, {})
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                collection === "send-atd" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-text-sm",
                                            children: [
                                                masterData === null || masterData === void 0 ? void 0 : (ref1 = masterData.live_stream_gift_atd) === null || ref1 === void 0 ? void 0 : ref1.description,
                                                "."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-mt-3 tw-grid tw-grid-cols-3 tw-gap-3",
                                            children: [
                                                masterData === null || masterData === void 0 ? void 0 : (ref2 = masterData.live_stream_gift_atd) === null || ref2 === void 0 ? void 0 : ref2.amounts.map(function(price) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "tw-cursor-pointer tw-relative tw-flex tw-items-center tw-border tw-rounded-5 tw-overflow-hidden before:tw-w-[5px] before:tw-h-full before:tw-bg-primary-main before:tw-absolute before:tw-left-0 before:tw-top-0 tw-p-2 ".concat(atd === price ? "tw-bg-[#EFFDFA] tw-border-primary-main" : "tw-bg-white tw-border-[#9E9E9E]"),
                                                            onClick: function() {
                                                                return setAtd(price);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                                    src: "/diamond-kam.png",
                                                                    alt: "diamond",
                                                                    className: "tw-w-5 tw-h-5 tw-mr-1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "tw-flex tw-flex-col",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "tw-font-bold tw-text-xs tw-text-primary-main",
                                                                            children: [
                                                                                price,
                                                                                " ATD ~"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "tw-font-bold tw-text-xs tw-text-warning-90",
                                                                            children: (0,app/* toMoney */.KP)(price * 100000, t)
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }, "amount-".concat(price))
                                                    });
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Link */.rU, {
                                                    className: "tw-cursor-pointer tw-relative tw-flex tw-items-center tw-border tw-border-primary-main tw-rounded-5 tw-overflow-hidden before:tw-w-[5px] before:tw-h-full before:tw-bg-primary-main before:tw-absolute before:tw-left-0 before:tw-top-0 tw-p-2 tw-bg-primary-main",
                                                    url: layouts_shared/* PagePath.AccountDepositPage */._.AccountDepositPage,
                                                    target: "_blank",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* DiamondPlusIcon */.yW, {}),
                                                            className: "tw-w-5 tw-h-5 tw-text-white"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "tw-flex tw-flex-col tw-text-white",
                                                            children: "Nạp ATD"
                                                        })
                                                    ]
                                                }, "deposit-atd")
                                            ]
                                        })
                                    ]
                                }),
                                collection != "send-atd" && listSticker.map(function(s) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                        className: "tw-relative tw-mr-3 tw-mb-3 tw-rounded-5 tw-cursor-pointer ".concat((sticker === null || sticker === void 0 ? void 0 : sticker.id) == s.id ? "tw-border tw-border-primary-main" : ""),
                                        onClick: function() {
                                            return setSticker(s);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                            alt: s.name,
                                            src: s.icon,
                                            className: "tw-w-10 tw-h-10 xl:tw-w-14 xl:tw-h-14",
                                            objectFit: "cover"
                                        })
                                    }, "sticker-".concat(s.name));
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex tw-justify-end tw-pt-2 tw-px-4 tw-bg-white tw-relative tw-z-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                    className: "tw-text-white tw-text-13 tw-bg-primary-main tw-px-4 tw-py-1 tw-uppercase !tw-w-auto !tw-rounded-5",
                    onClick: function() {
                        return chooseSticker();
                    },
                    loading: isLoading,
                    children: "Gửi tặng"
                })
            })
        ]
    });
};
/* harmony default export */ var chat_SendSticker = (/*#__PURE__*/(0,react.memo)(SendSticker));

;// CONCATENATED MODULE: ./features/livestream/detail/partials/chat/Comments/SendCommentBlock.tsx
















// eslint-disable-next-line react/display-name
var SendCommentBlock = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var _$ref;
    var userId = props.userId, liveStreamId = props.liveStreamId, t = props.t, status = props.status, collectionStickers = props.collectionStickers, setDisabled = props.setDisabled, isAuth = props.isAuth, onShowProducts = props.onShowProducts;
    var _$ref1 = (0,react.useState)(false), showSticker = _$ref1[0], setShowSticker = _$ref1[1];
    var _$ref2 = (0,react.useState)(false), show = _$ref2[0], setShow = _$ref2[1];
    var _$ref3 = (0,react.useState)(false), isLoadingGift = _$ref3[0], setLoadingGift = _$ref3[1];
    var commentRef = (0,react.useRef)(null);
    var _$ref4 = (0,api/* useAddCommentQuery */.fk)({
        onSuccess: function() {
            reset();
            react_hot_toast_esm/* default.success */.ZP.success(t("detail.message.add-comment-success"));
            setTimeout(function() {
                setDisabled();
            }, 5000);
        }
    }), mutate = _$ref4.mutate, isLoading = _$ref4.isLoading;
    var _$ref5 = (0,api/* useGiftAtd */.Mz)({
        onSuccess: function() {
            react_hot_toast_esm/* default.success */.ZP.success("Cảm ơn bạn đ\xe3 tặng atd cho An Thư. Ch\xfac bạn một ng\xe0y tốt l\xe0nh");
        },
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        }
    }), mutateGiftAtd = _$ref5.mutate;
    var _$ref6 = (0,index_esm/* useForm */.cI)({
        defaultValues: detail_const/* FormChatDefault */.Ww,
        resolver: (0,yup_module/* yupResolver */.X)(es/* object */.Ry({
            comment: es/* string */.Z_().trim().required(t("detail.message.comment-required"))
        }))
    }), reset = _$ref6.reset, control = _$ref6.control, handleSubmit = _$ref6.handleSubmit, errors = _$ref6.formState.errors;
    var onCommentClick = handleSubmit(function(data) {
        if (isLoading || !userId) return;
        mutate((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
            comment: data.comment,
            user_id: userId || 0,
            live_stream_id: +liveStreamId,
            images: null
        }));
        commentRef.current && commentRef.current.scrollToBottom();
    });
    var keyPress = (0,react.useCallback)(function(e) {
        if (e.keyCode === 13) {
            if (!isAuth) return setShow(true);
            return onCommentClick();
        }
    }, [
        isAuth,
        onCommentClick
    ]);
    // const keyPress = (e: any) => {
    //   if (e.keyCode === 13) {
    //     onCommentClick();
    //   }
    // };
    var onStickerClick = function() {
        setShowSticker(!showSticker);
    };
    var _$ref7 = (0,api/* useSendSticker */.Hu)({
        onSuccess: function() {
            setShowSticker(false);
        }
    }), SendStickerMutate = _$ref7.mutate, isLoadingSendSticker = _$ref7.isLoading;
    (0,react.useImperativeHandle)(ref, function() {
        return {
            sendComment: function(data) {
                mutate(data);
            }
        };
    });
    var sendSticker = function(s) {
        var payload = {
            live_stream_id: liveStreamId,
            sticker_id: s.id,
            sticker_collection_id: s.collection_id
        };
        setShowSticker(false);
        SendStickerMutate(payload);
    };
    var giftAtd = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(amount) {
            var data, _;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoadingGift(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            (0,api/* getSession */.Gg)()
                        ];
                    case 2:
                        data = _state.sent().data;
                        return [
                            4,
                            mutateGiftAtd({
                                amount: amount,
                                liveId: liveStreamId,
                                sessionId: data.session_id
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        _ = _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setLoadingGift(false);
                        setShowSticker(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function giftAtd(amount) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                children: showSticker && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                    initial: "stickerWrapperInitial",
                    exit: "stickerWrapperExit",
                    animate: "stickerWrapperAnimate",
                    transition: {
                        duration: 0.3
                    },
                    variants: {
                        stickerWrapperInitial: {
                            opacity: 0
                        },
                        stickerWrapperExit: {
                            opacity: 0
                        },
                        stickerWrapperAnimate: {
                            opacity: 1
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-absolute bottom-100-12 tw-left-0 tw-w-full tw-bg-white tw-rounded-5 tw-drop-shadow-lg custom-polygon-sticker",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-relative tw-w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-absolute tw-text-secondary-70 tw-top-3 tw-right-3 tw-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-cursor-pointer",
                                    onClick: function() {
                                        return setShowSticker(false);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                        className: "tw-w-3 tw-h-3",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* XIcon */.b0, {})
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-w-full tw-py-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chat_SendSticker, {
                                        giftAtd: giftAtd,
                                        t: t,
                                        isLoading: isLoadingSendSticker || isLoadingGift,
                                        collectionStickers: collectionStickers,
                                        sendSticker: sendSticker
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-gap-x-2 tw-items-center ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                        loading: isLoading,
                        onClick: onShowProducts,
                        className: "tw-flex tw-justify-center tw-p-2 !tw-rounded-full !tw-w-fit tw-bg-primary-main",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                            className: "tw-w-4 tw-h-4",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* DiamondField */.pj, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-flex-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextField */.nv, {
                            name: "comment",
                            control: control,
                            showErrorMessage: false,
                            variant: components/* InputVariant.Outlined */.Jf.Outlined,
                            error: (_$ref = errors.comment) === null || _$ref === void 0 ? void 0 : _$ref.message,
                            onKeyDown: keyPress,
                            placeholder: t("detail.form.label.comment") + "...",
                            containerClassName: "tw-bg-white tw-rounded-full !tw-border-0 tw-border-white tw-flex-1",
                            className: "tw-px-2 custom-placeholder "
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                        disabled: !userId,
                        loading: isLoading,
                        onClick: onCommentClick,
                        className: "tw-flex tw-justify-center tw-p-2 !tw-rounded-full !tw-w-fit tw-bg-primary-main",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                            className: "tw-w-4 tw-h-4",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SendIcon */.jE, {})
                        })
                    }),
                    status === detail_const/* LiveStreamStatus.LIVE_NOW */.zN.LIVE_NOW && !!collectionStickers.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                        disabled: !userId,
                        loading: isLoading,
                        onClick: onStickerClick,
                        className: "tw-flex tw-justify-center tw-p-2 !tw-rounded-full !tw-w-fit tw-bg-primary-main",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                            className: "tw-w-4 tw-h-4",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FlowerIcon */.pv, {})
                        })
                    })
                ]
            }),
            show && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Modal */.u_, {
                onClose: function() {
                    return setShow(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-items-center tw-justify-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-text-center",
                            children: "Vui l\xf2ng đăng nhập để sử dụng t\xednh năng n\xe0y."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                            className: "tw-mt-4 !tw-underline tw-text-lg",
                            url: {
                                pathname: layouts_shared/* PagePath.LoginPage */._.LoginPage
                            },
                            children: "Đăng nhập"
                        })
                    ]
                })
            })
        ]
    });
});

;// CONCATENATED MODULE: ./models/auction.ts
var AuctionType;
(function(AuctionType) {
    AuctionType["Public"] = "PUBLIC";
    AuctionType["InvitedOnly"] = "INVITED_ONLY";
})(AuctionType || (AuctionType = {}));

// EXTERNAL MODULE: ./features/livestream/detail/partials/chat/Comments/AuctionModal.tsx
var AuctionModal = __webpack_require__(59394);
;// CONCATENATED MODULE: ./features/livestream/detail/partials/chat/Comments/ProductAuction.tsx








var ProductAuction = function(param) {
    var product = param.product, productId = param.productId, isDiscount = param.isDiscount, t = param.t, userId = param.userId;
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), open = ref3[0], setOpen = ref3[1];
    var ref4 = (0,react.useState)(false), isInvited = ref4[0], setIsInvited = ref4[1];
    var handleOpenModal = function() {
        setOpen(true);
    };
    (0,react.useEffect)(function() {
        var ref;
        if ((ref = product.auction) === null || ref === void 0 ? void 0 : ref.id) {
            if (product.auction.type === AuctionType.InvitedOnly) {
                var ref1;
                (0,api/* getAuctionInvitedUsers */.vc)((ref1 = product.auction) === null || ref1 === void 0 ? void 0 : ref1.id).then(function(param) {
                    var data = param.data;
                    setIsInvited(!!data);
                });
            } else {
                setIsInvited(true);
            }
        }
    }, [
        product
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-bg-white tw-rounded-5 tw-p-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " tw-flex tw-gap-x-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                url: {
                                    pathname: layouts_shared/* PagePath.ProductDetailPage */._.ProductDetailPage,
                                    query: {
                                        id: "".concat((0,app/* createHandle */.UR)(product.product_name), "-").concat(productId, "-").concat(product.product_code)
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-relative !tw-w-20 !tw-h-20 tw-bg-center tw-bg-no-repeat tw-bg-cover tw-rounded-5",
                                    style: {
                                        backgroundImage: "url('".concat((0,app/* getProductImage */.C6)(product.images), "')")
                                    },
                                    title: product.product_name,
                                    children: isDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-w-6 tw-h-6 tw-absolute tw-top-2 tw-right-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                src: "/sale.png",
                                                className: "tw-w-full tw-h-full",
                                                alt: "sale"
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex-1 tw-flex tw-flex-col tw-gap-y-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                        className: "tw-w-full",
                                        url: {
                                            pathname: layouts_shared/* PagePath.ProductDetailPage */._.ProductDetailPage,
                                            query: {
                                                id: "".concat((0,app/* createHandle */.UR)(product.product_name), "-").concat(productId, "-").concat(product.product_code)
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "tw-text-primary-main tw-text-sm tw-font-semibold tw-line-clamp-1",
                                            dangerouslySetInnerHTML: {
                                                __html: product.product_name
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-text-13 ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-text-secondary-70",
                                                children: product.product_code
                                            }),
                                            "-",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("i", {
                                                children: [
                                                    "Gi\xe1 khởi điểm:",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-text-warning-90 tw-font-semibold",
                                                        children: (0,app/* toMoney */.KP)(((ref = product.auction) === null || ref === void 0 ? void 0 : ref.origin_price) || 0, t, layouts_shared/* PriceSymbol.$ */.hb.$)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-text-sm",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("i", {
                                            children: [
                                                "Gi\xe1 hiện tại:",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "tw-text-warning-90 tw-font-semibold",
                                                    children: (0,app/* toMoney */.KP)(((ref1 = product.auction) === null || ref1 === void 0 ? void 0 : ref1.sell_price) || 0, t, layouts_shared/* PriceSymbol.$ */.hb.$)
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-flex tw-justify-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Button */.zx, {
                            onClick: handleOpenModal,
                            disabled: ((ref2 = product.auction) === null || ref2 === void 0 ? void 0 : ref2.status) !== layouts_shared/* AuctionStatus.Started */.wo.Started || !userId || !isInvited,
                            className: "tw-bg-warning-90 tw-text-white tw-uppercase tw-flex tw-items-center tw-gap-x-2 tw-border-warning-90 tw-text-xs tw-w-max tw-px-6 tw-py-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* AuctionIcon */.CZ, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Đấu gi\xe1"
                                })
                            ]
                        })
                    })
                ]
            }),
            open && productId && /*#__PURE__*/ (0,jsx_runtime.jsx)(AuctionModal/* default */.Z, {
                t: t,
                handleCloseModal: function() {
                    return setOpen(false);
                },
                productCode: product.product_code,
                productName: product.product_name,
                productId: productId
            })
        ]
    });
};
/* harmony default export */ var Comments_ProductAuction = (ProductAuction);

;// CONCATENATED MODULE: ./features/livestream/detail/partials/chat/Comments/PinProduct.tsx






var PinnedProduct = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var product = props.product, productId = props.productId, t = props.t, isDisabled = props.isDisabled, userId = props.userId, onConsultClick = props.onConsultClick, liveStreamId = props.liveStreamId, orderProductId = props.orderProductId;
    var isDiscount = product.product_discount ? (0,app/* checkTime */.s)((ref = product.product_discount) === null || ref === void 0 ? void 0 : ref.started_at, (ref1 = product.product_discount) === null || ref1 === void 0 ? void 0 : ref1.ended_at) : false;
    if (product.product_discount && ((ref2 = product.product_discount) === null || ref2 === void 0 ? void 0 : ref2.status) === layouts_shared/* DiscountStatus.Ended */.YT.Ended) isDiscount = false;
    if (product.is_auction) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Comments_ProductAuction, {
        t: t,
        userId: userId,
        product: product,
        productId: productId,
        isDiscount: isDiscount
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-bg-white tw-rounded-5 tw-flex tw-gap-x-2 tw-p-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                url: {
                    pathname: layouts_shared/* PagePath.ProductDetailPage */._.ProductDetailPage,
                    query: {
                        id: "".concat((0,app/* createHandle */.UR)(product.product_name), "-").concat(productId, "-").concat(product.product_code)
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-relative !tw-w-20 !tw-h-20 tw-bg-center tw-bg-no-repeat tw-bg-cover tw-rounded-5",
                    style: {
                        backgroundImage: "url('".concat((0,app/* getProductImage */.C6)(product.images), "')")
                    },
                    title: product.product_name,
                    children: isDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-w-6 tw-h-6 tw-absolute tw-top-2 tw-right-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                src: "/sale.png",
                                className: "tw-w-full tw-h-full",
                                alt: "sale"
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex-1 tw-flex tw-flex-col tw-gap-y-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                        className: "tw-w-full tw-h-full",
                        url: {
                            pathname: layouts_shared/* PagePath.ProductDetailPage */._.ProductDetailPage,
                            query: {
                                id: "".concat((0,app/* createHandle */.UR)(product.product_name), "-").concat(productId, "-").concat(product.product_code)
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: "tw-text-primary-main tw-text-sm tw-font-semibold tw-line-clamp-1",
                            dangerouslySetInnerHTML: {
                                __html: product.product_name
                            }
                        })
                    }),
                    !product.quotation ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-text-secondary-70 tw-flex tw-flex-wrap tw-flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-text-13",
                                children: product.product_code
                            }),
                            product.product_discount && isDiscount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "tw-text-warning-90 tw-font-medium tw-text-13",
                                        children: (0,app/* toMoney */.KP)(product.price - product.price * ((ref3 = product.product_discount) === null || ref3 === void 0 ? void 0 : ref3.discount) / 100, t)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "\xa0~\xa0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "tw-text-primary-main tw-font-medium tw-text-13",
                                        children: (0,app/* toMoney */.KP)(product.token - product.token * ((ref4 = product.product_discount) === null || ref4 === void 0 ? void 0 : ref4.discount) / 100, t, layouts_shared/* PriceSymbol.Atd */.hb.Atd)
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex tw-text-xs tw-items-center lg:tw-gap-x-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "tw-text-warning-90 tw-font-medium tw-text-13",
                                        children: (0,app/* toMoney */.KP)(product.price, t)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "\xa0~\xa0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "tw-text-primary-main tw-font-medium tw-text-13",
                                        children: (0,app/* toMoney */.KP)(product.token, t, layouts_shared/* PriceSymbol.Atd */.hb.Atd)
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-text-secondary-70",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "tw-text-13",
                                    children: product.product_code
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-text-warning-90",
                                    children: t("layout:btn.contact")
                                })
                            ]
                        })
                    }),
                    !product.quotation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-justify-end tw-gap-x-4 lg:tw-gap-x-2 xl:tw-gap-x-4 tw-text-xs tw-items-center",
                        children: [
                            isDisabled || product.quantity <= 0 || orderProductId === productId ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Button */.zx, {
                                disabled: !userId,
                                className: "!tw-rounded-5 tw-py-1 tw-uppercase tw-px-3 tw-opacity-70 tw-flex tw-items-center !tw-w-[120px] lg:!tw-w-[110px] xl:!tw-w-[120px]",
                                variant: components/* ButtonVariant.Outlined */.Wu.Outlined,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ChatLineIcon */.Ce, {}),
                                        className: "tw-w-4 tw-h-4 tw-mr-3 lg:tw-mr-2 xl:tw-mr-3"
                                    }),
                                    t("layout:btn.consult")
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Button */.zx, {
                                disabled: !userId,
                                onClick: onConsultClick,
                                className: "!tw-rounded-5 tw-py-1 tw-uppercase tw-px-3 tw-opacity-70 tw-flex tw-items-center !tw-w-[120px] lg:!tw-w-[110px] xl:!tw-w-[120px] tw-text-base lg:tw-text-sm xl:tw-text-base",
                                variant: components/* ButtonVariant.Outlined */.Wu.Outlined,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ChatLineIcon */.Ce, {}),
                                        className: "tw-w-4 tw-h-4 tw-mr-3 lg:tw-mr-2 xl:tw-mr-3"
                                    }),
                                    t("layout:btn.consult")
                                ]
                            }),
                            product.quantity <= 0 || product.status != layouts_shared/* ProductStatus.Availability */.Pt.Availability || orderProductId === productId ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Button */.zx, {
                                disabled: true,
                                className: "!tw-rounded-5 tw-text-white tw-bg-primary-main tw-py-1 tw-px-3 tw-flex tw-items-center tw-justify-center !tw-w-max lg:!tw-w-[125px] xl:!tw-w-max tw-uppercase tw-text-base lg:tw-text-sm xl:tw-text-base",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* WalletIcon */.o, {}),
                                        className: "tw-w-4 tw-h-4 tw-mr-3 lg:tw-mr-2 xl:tw-mr-3 tw-text-white"
                                    }),
                                    t("layout:btn.deposited")
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Link */.rU, {
                                url: {
                                    pathname: layouts_shared/* PagePath.ProductDepositPage */._.ProductDepositPage,
                                    query: {
                                        id: productId,
                                        stream_id: liveStreamId
                                    }
                                },
                                target: "_blank",
                                className: "tw-bg-primary-main !tw-text-white !tw-w-max lg:!tw-w-[125px] xl:!tw-w-max tw-gap-x-1 tw-border tw-px-3 tw-py-1 tw-rounded-5 tw-flex tw-items-center tw-justify-center tw-uppercase tw-text-base lg:tw-text-sm xl:tw-text-base",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* WalletIcon */.o, {}),
                                        className: "tw-w-4 tw-h-4 tw-mr-3 lg:tw-mr-2 xl:tw-mr-3 tw-text-white"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: t("layout:btn.order")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./features/livestream/detail/partials/chat/index.tsx













var ChatPartial = function(props) {
    var liveStreamId = props.liveStreamId, status = props.status, pinnedProduct = props.pinnedProduct, isAuth = props.isAuth, t = props.t, collectionStickers = props.collectionStickers, messageData = props.messageData, retry = props.retry, showLotteryBtn = props.showLotteryBtn, hideLotteryBtn = props.hideLotteryBtn, lotteryGame = props.lotteryGame, commentList = props.commentList, defaultOffset = props.defaultOffset;
    var LOTTERY_URL = "https://landing.anthu.vn/lottery/user.html";
    var profile = (0,contexts_profile/* useProfile */.Un)();
    var userId = (profile === null || profile === void 0 ? void 0 : profile.id) || null;
    var commentRef = (0,react.useRef)(null);
    var sendCommentRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(), orderDeposit = ref[0], setOrderDeposit = ref[1];
    var ref1 = (0,react.useState)(), ticket = ref1[0], setTicket = ref1[1];
    var ref2 = (0,react.useState)(), winnerAuction = ref2[0], setWinnerAuction = ref2[1];
    var ref3 = (0,react.useState)(false), isDisabled = ref3[0], setIsDisabled = ref3[1];
    var ref4 = (0,react.useState)(false), showPopup = ref4[0], setShowPopup = ref4[1];
    var ref5 = (0,react.useState)(), orderId = ref5[0], setOrderId = ref5[1];
    var ref6 = (0,react.useState)((lotteryGame === null || lotteryGame === void 0 ? void 0 : lotteryGame.status) || layouts_shared/* LotteryGameStatus.Ended */.Ck.Ended), gameStatus = ref6[0], setGameStatus = ref6[1];
    var ref7 = (0,react.useState)((lotteryGame === null || lotteryGame === void 0 ? void 0 : lotteryGame.id) || null), gameId = ref7[0], setGameId = ref7[1];
    var ref8 = (0,react.useState)(""), myReward = ref8[0], setMyReward = ref8[1];
    var ref9 = (0,react.useState)(true), showProducts = ref9[0], setShowProducts = ref9[1];
    var ref10 = (0,api/* useTicketByUserQuery */.$E)({
        lottery_game_id: gameId || ""
    }, {
        enabled: false,
        retry: false,
        onSuccess: function(param) {
            var data = param.data;
            return setTicket(data.number);
        },
        onError: function() {
            return setTicket(undefined);
        }
    }), refetchTicketByUser = ref10.refetch;
    var ref11 = (0,chat_api/* useCreateOrderChat */.qW)({}), sendMessage = ref11.mutate;
    var ref12 = (0,api/* useCreateChatConversation */.uJ)({
        onSuccess: function(param) {
            var data = param.data;
            var conversation = data.conversation;
            sendMessage({
                id: conversation.id,
                data: {
                    content: "TV ".concat(conversation.type_code),
                    images: [],
                    type: "text"
                }
            });
        },
        onError: function(param) {
            var message = param.message;
        }
    }), mutate = ref12.mutate, isCreateChatConversationLoading = ref12.isLoading;
    var ref13 = (0,detail_api/* useFetchConversationByProductQuery */.uK)((pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.product_id) || 0, {
        retry: 0,
        enabled: false,
        onSuccess: function(data) {
            var ref = data.data || {}, id = ref.id, type_code = ref.type_code, type = ref.type;
            sendMessage({
                id: id,
                data: {
                    content: "TV ".concat(type_code),
                    images: [],
                    type: "text"
                }
            });
        },
        onError: function() {
            return mutate({
                title: (pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.products.product_name) || "",
                type_id: (pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.product_id) || 0,
                type_image: (0,app/* getProductImage */.C6)(pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.products.images) || "",
                type_code: (pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.products.product_code) || "",
                type: detail_const/* ConversationType.Product */.i1.Product
            });
        }
    }), fetchConversation = ref13.refetch, isFetchConversationLoading = ref13.isLoading;
    var setEndLottery = function() {
        setTimeout(function() {
            setGameStatus(layouts_shared/* LotteryGameStatus.Ended */.Ck.Ended);
            setTicket(undefined);
        }, 10000);
    };
    var setProductOrder = function(code, image, fullName, id) {
        setTimeout(function() {
            setOrderDeposit({
                productCode: code,
                productImage: image,
                fullname: fullName,
                isShow: true,
                id: id
            });
        }, 500);
    };
    (0,react.useEffect)(function() {
        if (gameId && showLotteryBtn && !ticket) refetchTicketByUser();
    }, [
        gameId,
        showLotteryBtn,
        ticket,
        refetchTicketByUser
    ]);
    (0,react.useEffect)(function() {
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LotterySocketMethod.UserConfirmTicket */.Sf.UserConfirmTicket) {
            var ref;
            if (((ref = messageData === null || messageData === void 0 ? void 0 : messageData.data.users) === null || ref === void 0 ? void 0 : ref.id) === userId) refetchTicketByUser();
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LotterySocketMethod.OpenLottery */.Sf.OpenLottery) {
            setGameStatus(layouts_shared/* LotteryGameStatus.Pending */.Ck.Pending);
            setGameId(messageData.data.lottery_game_id || null);
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LotterySocketMethod.EndLottery */.Sf.EndLottery) {
            setEndLottery();
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LotterySocketMethod.AdminPickTicketLottery */.Sf.AdminPickTicketLottery) {
            var ref1;
            if (((ref1 = messageData === null || messageData === void 0 ? void 0 : messageData.data.users) === null || ref1 === void 0 ? void 0 : ref1.id) === userId) {
                var ref2;
                setShowPopup(true);
                setMyReward(((ref2 = messageData.data.prize) === null || ref2 === void 0 ? void 0 : ref2.name) || "");
            }
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LiveProductMethod.CreateOrder */.zN.CreateOrder) {
            var ref3, ref4;
            if (((ref3 = messageData === null || messageData === void 0 ? void 0 : messageData.data.product) === null || ref3 === void 0 ? void 0 : ref3.id) && ((ref4 = messageData === null || messageData === void 0 ? void 0 : messageData.data.product) === null || ref4 === void 0 ? void 0 : ref4.id) === (pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.product_id)) {
                var ref5, ref6, ref7, ref8;
                var dataOrder = messageData === null || messageData === void 0 ? void 0 : messageData.data;
                setOrderId((ref5 = dataOrder.product) === null || ref5 === void 0 ? void 0 : ref5.id);
                setProductOrder(pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.products.product_code, (dataOrder === null || dataOrder === void 0 ? void 0 : (ref6 = dataOrder.product) === null || ref6 === void 0 ? void 0 : ref6.image) || "", (dataOrder === null || dataOrder === void 0 ? void 0 : (ref7 = dataOrder.users) === null || ref7 === void 0 ? void 0 : ref7.fullname) || "", (dataOrder === null || dataOrder === void 0 ? void 0 : (ref8 = dataOrder.product) === null || ref8 === void 0 ? void 0 : ref8.id) || 0);
            }
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LiveProductMethod.AuctionEnded */.zN.AuctionEnded) {
            if (messageData.data.winner) {
                var winner = messageData.data.winner;
                setWinnerAuction({
                    fullName: winner.fullname,
                    productCode: messageData.data.product_code || ""
                });
            }
        }
    }, [
        messageData,
        pinnedProduct,
        refetchTicketByUser,
        userId
    ]);
    (0,react.useEffect)(function() {
        if ((pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.product_id) !== (orderDeposit === null || orderDeposit === void 0 ? void 0 : orderDeposit.id)) {
            setOrderDeposit(undefined);
        }
    }, [
        orderDeposit === null || orderDeposit === void 0 ? void 0 : orderDeposit.id,
        pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.product_id
    ]);
    var ref14 = (0,api/* useCreateCodeTicketQuery */.ll)({
        onSuccess: function(param) {
            var code = param.data.code;
            if (!code) return;
            var newWindow = window.open("".concat(LOTTERY_URL, "?code=").concat(encodeURIComponent(code)), "_blank");
            if (newWindow) newWindow.opener = null;
        }
    }), mutateCreateCode = ref14.mutate, loadingCreateCode = ref14.isLoading;
    var onConsultClick = function() {
        if (pinnedProduct) {
            setIsDisabled(true);
            sendCommentRef.current && sendCommentRef.current.sendComment({
                comment: "TV ".concat(pinnedProduct.products.product_code),
                user_id: userId || 0,
                live_stream_id: +liveStreamId,
                images: null
            });
            return fetchConversation();
        }
    };
    var directPlayGame = function() {
        if (gameId && gameStatus === layouts_shared/* LotteryGameStatus.Pending */.Ck.Pending) mutateCreateCode({
            lottery_game_id: gameId
        });
    };
    var sendComment = function(code) {
        if (code) {
            setIsDisabled(true);
            sendCommentRef.current && sendCommentRef.current.sendComment({
                comment: "TV ".concat(code),
                user_id: userId || 0,
                live_stream_id: +liveStreamId,
                images: null
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-bg-muted-90 tw-rounded-5 tw-h-80-screen tw-flex tw-flex-col tw-gap-y-4 tw-p-4 tw-justify-between",
                children: [
                    showLotteryBtn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: gameStatus !== layouts_shared/* LotteryGameStatus.Ended */.Ck.Ended && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-bg-white tw-rounded-5 tw-px-4 tw-pt-2 tw-pb-4 tw-gap-x-2 tw-relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                    src: "/confetti-flat.gif",
                                    alt: "confetti",
                                    className: "tw-w-16 tw-h-16"
                                }),
                                ticket ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex-1 tw-text-primary-main",
                                    children: [
                                        t("detail.label.joined-lottery"),
                                        ": ",
                                        ticket
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-text-primary-main",
                                            children: t("detail.label.invite-join-lottery")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-flex tw-justify-end tw-mt-4 tw-w-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                                disabled: loadingCreateCode || gameStatus !== layouts_shared/* LotteryGameStatus.Pending */.Ck.Pending,
                                                className: "tw-bg-primary-main tw-text-xs tw-uppercase tw-text-white tw-py-1 tw-px-6 tw-rounded !tw-w-max",
                                                onClick: directPlayGame,
                                                children: t("layout:btn.join")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-absolute tw-right-2 tw-cursor-pointer",
                                    onClick: hideLotteryBtn,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* XLineIcon */.pC, {}),
                                        className: "tw-w-4 tw-h-4 tw-text-secondary-70"
                                    })
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: pinnedProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(PinnedProduct, {
                            t: t,
                            product: pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.products,
                            productId: pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.product_id,
                            isDisabled: isDisabled,
                            orderProductId: orderId,
                            userId: userId,
                            liveStreamId: liveStreamId,
                            onConsultClick: onConsultClick
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Comments, {
                        ref: commentRef,
                        isAuth: isAuth,
                        liveId: liveStreamId,
                        retry: retry,
                        messageData: messageData,
                        commentList: commentList,
                        defaultOffset: defaultOffset,
                        isShowProducts: showProducts,
                        sendComment: sendComment,
                        hiddenProducts: function() {
                            return setShowProducts(false);
                        },
                        t: t
                    }),
                    status === detail_const/* LiveStreamStatus.LIVE_NOW */.zN.LIVE_NOW && pinnedProduct && orderDeposit && orderDeposit.isShow && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-gap-y-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-p-2 tw-flex tw-rounded tw-items-center a-flip-left",
                                style: {
                                    backgroundColor: "#EDFFFC"
                                },
                                children: [
                                    orderDeposit.productImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                        className: "tw-h-8 tw-w-8",
                                        alt: orderDeposit.productCode,
                                        src: orderDeposit.productImage
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "tw-font-light tw-flex tw-flex-1 tw-ml-2",
                                        style: {
                                            color: "#11695A",
                                            fontSize: "13px"
                                        },
                                        children: [
                                            "Qu\xfd kh\xe1ch ",
                                            orderDeposit.fullname,
                                            " đ\xe3 cọc th\xe0nh c\xf4ng ",
                                            orderDeposit.productCode
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    winnerAuction && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-gap-y-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-p-2 tw-flex tw-rounded tw-items-center a-flip-left",
                                style: {
                                    backgroundColor: "#FFF7E3"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "tw-font-light tw-flex tw-flex-1 tw-ml-2",
                                    style: {
                                        color: "#A54400",
                                        fontSize: "13px"
                                    },
                                    children: [
                                        "Qu\xfd kh\xe1ch ",
                                        winnerAuction.fullName,
                                        " đ\xe3 đấu gi\xe1 th\xe0nh c\xf4ng ",
                                        winnerAuction.productCode
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SendCommentBlock, {
                        ref: sendCommentRef,
                        t: t,
                        liveStreamId: liveStreamId,
                        status: status,
                        collectionStickers: collectionStickers,
                        setDisabled: function() {
                            return setIsDisabled(false);
                        },
                        isAuth: isAuth,
                        userId: userId,
                        onShowProducts: function() {
                            return setShowProducts(function(prev) {
                                return !prev;
                            });
                        }
                    })
                ]
            }),
            showPopup && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* ModalCustom */.wW, {
                className: "tw-rounded-2xl tw-overflow-hidden tw-w-60 md:tw-w-96 tw-flex tw-items-center tw-flex-col",
                childrenClass: "!tw-gap-y-0 tw-w-full tw-items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                        src: "/confetti-flat.gif",
                        alt: "confetti",
                        className: "tw-w-52 tw-h-52"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-mt-2 tw-text-center",
                        children: "Ch\xfac mừng bạn đ\xe3 chiến thắng"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-mt-1 tw-text-center",
                        children: myReward
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                            className: "tw-bg-primary-main tw-text-white tw-mt-4 tw-w-full tw-rounded-full",
                            onClick: function() {
                                return setShowPopup(false);
                            },
                            children: "OK"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var chat = (ChatPartial);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(22004);
// EXTERNAL MODULE: ./node_modules/react-share/es/FacebookShareButton.js + 4 modules
var FacebookShareButton = __webpack_require__(8136);
;// CONCATENATED MODULE: ./features/livestream/detail/partials/player/countdown.tsx



var CountDown = function(param) {
    var endTime = param.endTime, handleCountDown = param.handleCountDown;
    var countDownDate = new Date(endTime).getTime();
    var ref = (0,react.useState)("--"), minute = ref[0], setMinute = ref[1];
    var ref1 = (0,react.useState)("--"), second = ref1[0], setSecond = ref1[1];
    (0,react.useEffect)(function() {
        var distance = 0;
        var interval = setInterval(function() {
            var now = (0,app/* parseUtcTime */.Ec)();
            distance = countDownDate - now;
            setMinute((0,app/* pad */.vk)(Math.floor(distance % (1000 * 60 * 60) / (1000 * 60))));
            setSecond((0,app/* pad */.vk)(Math.floor(distance % (1000 * 60) / 1000)));
            if (Math.round(distance / 1000) < 1) {
                clearInterval(interval);
                handleCountDown && handleCountDown();
            // router.reload();
            }
        }, 1000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        countDownDate,
        endTime,
        handleCountDown
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: "".concat(minute, ":").concat(second)
        })
    });
};

;// CONCATENATED MODULE: ./features/livestream/detail/partials/player/Lucky.tsx








var LuckyPartial = function(param) {
    var lucky = param.lucky, callRefetch = param.callRefetch;
    var ref = (0,react.useState)(null), dataOpenLucky = ref[0], setData = ref[1];
    // const [isCountdown, setShowCountDown] = useState<boolean>(isShow);
    var mutate = (0,api/* useOpenBoxLucky */.lh)({
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data;
            if (data.id) {
                setData(data);
                callRefetch();
            }
        }
    }).mutate;
    var isCountdown = !!(lucky === null || lucky === void 0 ? void 0 : lucky.time_can_open_next_box) && new Date(lucky === null || lucky === void 0 ? void 0 : lucky.time_can_open_next_box).getTime() > (0,app/* parseUtcTime */.Ec)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-justify-center tw-flex-col tw-items-center tw-cursor-pointer tw-relative",
                onClick: function() {
                    return !isCountdown && mutate(lucky === null || lucky === void 0 ? void 0 : lucky.id);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                        className: "tw-w-10 tw-h-10",
                        src: isCountdown ? "/gift-f.gif" : "/icons8-gift.gif",
                        alt: "lucky gif"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-border tw-border-white tw-rounded-5 tw-px-2 tw-flex tw-justify-center tw-items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                            objectFit: "contain",
                            className: "tw-w-16 tw-h-5",
                            src: "/luck.png",
                            alt: "luck"
                        })
                    }),
                    isCountdown && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-text-white tw-text-xs tw-px-2 tw-bg-black tw-bg-opacity-70 tw-absolute tw-z-10 tw--bottom-7",
                            style: {
                                borderRadius: "3px",
                                paddingTop: "2px",
                                paddingBottom: "2px"
                            },
                            children: lucky && (lucky === null || lucky === void 0 ? void 0 : lucky.time_can_open_next_box) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CountDown, {
                                endTime: lucky === null || lucky === void 0 ? void 0 : lucky.time_can_open_next_box,
                                handleCountDown: function() {
                                    return callRefetch();
                                }
                            })
                        })
                    })
                ]
            }),
            dataOpenLucky && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Modal */.u_, {
                className: "tw-p-0 tw-relative !tw-bg-transparent !tw-max-w-xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* ModalBody */.fe, {
                        className: "tw-p-0 tw-relative tw-h-96 md:tw-h-164 tw-w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-flex tw-justify-center tw-items-center tw-w-11 tw-h-11 tw-absolute tw--right-5 tw--top-5 tw-rounded-full tw-border tw-border-red-500 tw-z-50 tw-cursor-pointer",
                                onClick: function() {
                                    return setData(null);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-flex tw-w-9 tw-h-9 tw-rounded-full tw-p-2 tw-bg-white tw-items-center tw-justify-center tw-text-red-500",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                        className: "tw-w-full tw-h-full",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* XLineIcon */.pC, {})
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                className: "tw-w-full tw-h-full tw-rounded-10 tw-overflow-hidden",
                                src: dataOpenLucky === null || dataOpenLucky === void 0 ? void 0 : dataOpenLucky.attachment_url,
                                alt: "bg-lx",
                                objectFit: "cover"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ModalFooter */.mz, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookShareButton/* default */.Z, {
                            className: "tw-w-full",
                            url: (dataOpenLucky === null || dataOpenLucky === void 0 ? void 0 : dataOpenLucky.attachment_url) || "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-w-full tw-py-2 tw-rounded-5 tw-bg-white tw-border-white !tw-text-secondary-70",
                                children: "Chia sẻ"
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./features/livestream/detail/partials/lottery/list.tsx


var ListOfParticipants = function(props) {
    var participants = props.participants;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-flex tw-flex-col tw-gap-y-1 tw-h-auto tw-w-max",
        children: participants.length > 0 && participants.map(function(participant) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-bg-white tw-bg-opacity-40 md:tw-bg-opacity-25 tw-rounded-10 tw-px-2 tw-py-1 tw-w-24 md:tw-w-28 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-text-xs tw-w-full tw-text-secondary-70 md:tw-text-secondary-51 tw-line-clamp-1",
                        children: participant.fullName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-text-white tw-mt-0 md:tw-mt-1 tw-text-xs md:tw-text-13",
                        children: participant.number
                    })
                ]
            }, participant.number);
        })
    });
};

;// CONCATENATED MODULE: ./features/livestream/detail/partials/lottery/Confetti.tsx



var Confetti = function(param) {
    var title = param.title, wrapperClass = param.wrapperClass, key = param.key;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: wrapperClass,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "tw-mr-2 tw-text-xs md:tw-text-13",
                children: title
            }),
            [
                1,
                2,
                3
            ].map(function(n) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                    src: "/confetti-flat.gif",
                    className: "tw-w-4 tw-h-4 md:tw-w-6 md:tw-h-6",
                    alt: "confetti"
                }, "".concat(key, "--").concat(n));
            })
        ]
    });
};
/* harmony default export */ var lottery_Confetti = (Confetti);

;// CONCATENATED MODULE: ./features/livestream/detail/partials/lottery/index.tsx








var LotteryPartial = function(props) {
    var t = props.t, gameId = props.gameId, showLotteryBtn = props.showLotteryBtn, messageData = props.messageData, gameStatus = props.gameStatus, isAuth = props.isAuth, liveStreamId = props.liveStreamId;
    var ref = (0,react.useState)([]), participants = ref[0], setParticipants = ref[1];
    var ref1 = (0,react.useState)(gameStatus), status = ref1[0], setStatus = ref1[1];
    var ref2 = (0,react.useState)(gameStatus === layouts_shared/* LotteryGameStatus.Pending */.Ck.Pending ? layouts_shared/* LotteryTicketStatus.Pending */.Jz.Pending : layouts_shared/* LotteryTicketStatus.CloseList */.Jz.CloseList), ticketStatus = ref2[0], setTicketStatus = ref2[1];
    var ref3 = (0,react.useState)(0), countUser = ref3[0], setCountUser = ref3[1];
    var ref4 = (0,api/* useListOfParticipantsQuery */.pC)({
        lottery_game_id: gameId,
        offset: 0,
        limit: 5,
        status: ticketStatus
    }, {
        enabled: false,
        retry: false,
        onSuccess: function(param) {
            var data = param.data, total_records = param.total_records;
            if (!data) {
                setCountUser(0);
                return setParticipants([]);
            }
            var _p = data.sort(function(a, b) {
                return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
            }).map(function(d) {
                return {
                    number: d.number,
                    fullName: d.users.fullname
                };
            });
            setCountUser(total_records);
            setParticipants(_p);
        }
    }), refetchParticipants = ref4.refetch;
    (0,react.useEffect)(function() {
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LotterySocketMethod.UserConfirmTicket */.Sf.UserConfirmTicket) {
            var ref, ref1, ref2;
            var _p = {
                number: ((ref = messageData.data) === null || ref === void 0 ? void 0 : ref.number) || 0,
                fullName: ((ref1 = messageData.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.users) === null || ref2 === void 0 ? void 0 : ref2.fullname) || ""
            };
            setCountUser(function(prev) {
                return prev + 1;
            });
            setParticipants(function(prev) {
                if (prev.length > 4) {
                    return (0,_to_consumable_array/* default */.Z)(prev.slice(0, 4)).concat([
                        _p
                    ]);
                }
                return (0,_to_consumable_array/* default */.Z)(prev).concat([
                    _p
                ]);
            });
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LotterySocketMethod.OpenLottery */.Sf.OpenLottery) {
            setTicketStatus(layouts_shared/* LotteryTicketStatus.Pending */.Jz.Pending);
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LotterySocketMethod.CloseListLottery */.Sf.CloseListLottery) {
            setStatus(layouts_shared/* LotteryGameStatus.Starting */.Ck.Starting);
            setTicketStatus(layouts_shared/* LotteryTicketStatus.CloseList */.Jz.CloseList);
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LotterySocketMethod.AdminPickTicketLottery */.Sf.AdminPickTicketLottery) {
            setStatus(layouts_shared/* LotteryGameStatus.Ended */.Ck.Ended);
        }
    }, [
        messageData
    ]);
    (0,react.useEffect)(function() {
        if (gameId) refetchParticipants();
    }, [
        liveStreamId,
        gameId,
        refetchParticipants,
        ticketStatus
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-items-center tw-w-max tw-cursor-pointer",
                onClick: isAuth ? showLotteryBtn : function() {},
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                        src: "/confetti-flat.gif",
                        className: "tw-w-10 tw-h-10 md:tw-w-16 md:tw-h-16",
                        alt: "confetti"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-border tw-rounded-5 tw-border-white tw-w-12 tw-h-4 md:tw-w-20 md:tw-h-5 tw-flex tw-items-center tw-justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                            src: "/lottery.svg",
                            className: "tw-w-6 tw-h-3 md:tw-w-10 md:tw-h-5",
                            alt: "lottery",
                            objectFit: "contain"
                        })
                    })
                ]
            }),
            status === layouts_shared/* LotteryGameStatus.Pending */.Ck.Pending && /*#__PURE__*/ (0,jsx_runtime.jsx)(lottery_Confetti, {
                wrapperClass: "tw-mt-2 tw-pt-1 md:tw-mt-3 tw-bg-black tw-bg-opacity-30 tw-text-white tw-rounded-full tw-px-2 md:tw-px-3 tw-pb-1 tw-flex tw-items-end",
                title: t("detail.label.start-lottery")
            }, "pending"),
            countUser > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-mt-2 tw-text-xs md:tw-text-13 tw-text-white",
                children: [
                    countUser,
                    " ",
                    t("detail.label.user-join")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-mt-3 md:tw-mt-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListOfParticipants, {
                    participants: participants
                })
            }),
            status === layouts_shared/* LotteryGameStatus.Starting */.Ck.Starting && /*#__PURE__*/ (0,jsx_runtime.jsx)(lottery_Confetti, {
                wrapperClass: "tw-mt-1 md:tw-mt-3 tw-bg-black tw-bg-opacity-30 tw-text-white tw-rounded-full tw-px-3 tw-py-1 tw-flex tw-items-end",
                title: t("detail.label.end-list")
            }, "starting")
        ]
    });
};

;// CONCATENATED MODULE: ./features/livestream/detail/partials/player/AuctionCountDown.tsx



var AuctionCountDown = function(param) {
    var endTime = param.endTime, showCountDown = param.showCountDown;
    var countDownDate = new Date(endTime).getTime();
    var ref = (0,react.useState)(true), show = ref[0], setShow = ref[1];
    var ref1 = (0,react.useState)("0"), hours = ref1[0], setHours = ref1[1];
    var ref2 = (0,react.useState)("0"), minute = ref2[0], setMinute = ref2[1];
    var ref3 = (0,react.useState)("0"), second = ref3[0], setSecond = ref3[1];
    (0,react.useEffect)(function() {
        var distance = 0;
        var interval = setInterval(function() {
            var now = (0,app/* parseUtcTime */.Ec)();
            distance = countDownDate - now;
            setHours((0,app/* pad */.vk)(Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60))));
            setMinute((0,app/* pad */.vk)(Math.floor(distance % (1000 * 60 * 60) / (1000 * 60))));
            setSecond((0,app/* pad */.vk)(Math.floor(distance % (1000 * 60) / 1000)));
            if (Math.round(distance / 1000) === 1) {
                setShow(false);
                clearInterval(interval);
                showCountDown && showCountDown();
            // router.reload();
            }
        }, 1000);
        return function() {
            return clearInterval(interval);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        endTime
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-text-white tw-flex tw-items-center tw-gap-x-1 tw-text-26 tw-font-semibold",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-flex tw-flex-col tw-text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " tw-text-white tw-flex tw-items-center tw-justify-center tw-w-[40px]",
                        children: hours
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: ":"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-flex tw-flex-col tw-text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " tw-text-white tw-flex tw-items-center tw-justify-center tw-w-[40px] ",
                        children: minute
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: ":"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-flex tw-flex-col tw-text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " tw-text-white tw-flex tw-items-center tw-justify-center tw-w-[40px]",
                        children: second
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var player_AuctionCountDown = (AuctionCountDown);

;// CONCATENATED MODULE: ./features/livestream/detail/partials/player/index.tsx
/* eslint-disable @next/next/no-img-element */ 















var PlayerPartial = function(param) {
    var url = param.url, productsRange = param.productsRange, pinnedProduct = param.pinnedProduct, setPinnedProduct = param.setPinnedProduct, liveStreamId = param.liveStreamId, liveStatus = param.liveStatus, t = param.t, lotteryGame = param.lotteryGame, isAuth = param.isAuth, sticker = param.sticker, messageData = param.messageData, showLotteryBtn = param.showLotteryBtn, hideLotteryBtn = param.hideLotteryBtn, luckyDetail = param.luckyDetail;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var router = (0,next_router.useRouter)();
    var profile = (0,contexts_profile/* useProfile */.Un)();
    var ref7 = (0,api/* useWatchVideoQuery */.Ll)(), mutateWatchVideo = ref7.mutate;
    var ref8 = (0,api/* useEndWatchVideoQuery */.B4)(), mutateEndWatchVideo = ref8.mutate;
    var ref9 = (0,react.useState)(false), isVideoError = ref9[0], setVideoError = ref9[1];
    var ref10 = (0,react.useState)(""), videoHeight = ref10[0], setVideoHeight = ref10[1];
    var ref11 = (0,react.useState)(null), lucky = ref11[0], setLucky = ref11[1];
    var ref12 = (0,react.useState)(null), gameId = ref12[0], setGameId = ref12[1];
    var ref13 = (0,react.useState)((lotteryGame === null || lotteryGame === void 0 ? void 0 : lotteryGame.status) || layouts_shared/* LotteryGameStatus.Ended */.Ck.Ended), gameStatus = ref13[0], setGameStatus = ref13[1];
    var refDiv = (0,react.useRef)(null);
    var playerRef = (0,react.useRef)(null);
    var gameRef = (0,react.useRef)(null);
    var start = router.query.start ? parseInt(router.query.start + "") : 0;
    console.log(luckyDetail);
    (0,react.useEffect)(function() {
        setGameId((lotteryGame === null || lotteryGame === void 0 ? void 0 : lotteryGame.id) || null);
    }, [
        lotteryGame === null || lotteryGame === void 0 ? void 0 : lotteryGame.id
    ]);
    (0,react.useEffect)(function() {
        setLucky(luckyDetail);
    }, [
        liveStreamId,
        luckyDetail
    ]);
    (0,react.useEffect)(function() {
        if (isAuth) mutateWatchVideo({});
    }, [
        isAuth,
        mutateWatchVideo
    ]);
    var ref14 = (0,api/* useFetchLuckyBuyLiveIdQuery */.mZ)(liveStreamId, {
        enabled: false,
        retry: false,
        onSuccess: function(param) {
            var data = param.data;
            if (data.status === layouts_shared/* LuckyStatus.PROCESSING */.oj.PROCESSING) setLucky(data);
        },
        onError: function() {
            setLucky(null);
        }
    }), refetchLucky = ref14.refetch;
    (0,react.useEffect)(function() {
        var handleTabClose = function(event) {
            event.preventDefault();
            if (isAuth) mutateEndWatchVideo({
                enable: false
            });
        };
        window.addEventListener("beforeunload", handleTabClose);
        return function() {
            window.removeEventListener("beforeunload", handleTabClose);
        };
    }, [
        isAuth,
        mutateEndWatchVideo
    ]);
    var onVideoPlaying = function(param) {
        var currentPlayedSecond = param.playedSeconds, played = param.played;
        if (liveStatus !== detail_const/* LiveStreamStatus.LIVE_NOW */.zN.LIVE_NOW) {
            var currentProductRange = productsRange.find(function(param) {
                var range = param.range;
                var _range = (0,_sliced_to_array/* default */.Z)(range, 2), rangeStart = _range[0], rangeEnd = _range[1];
                return rangeStart <= currentPlayedSecond && rangeEnd >= currentPlayedSecond;
            });
            if (currentProductRange) {
                var product = currentProductRange.product;
                var currentProductId = product.product_id;
                if (currentProductId !== (pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.product_id) && product.products.status !== layouts_shared/* ProductStatus.Hide */.Pt.Hide) {
                    setPinnedProduct(product);
                }
            }
        }
    };
    (0,react.useEffect)(function() {
        setVideoError(false);
    }, [
        url
    ]);
    (0,react.useEffect)(function() {
        if (refDiv) {
            var ref;
            setVideoHeight(refDiv === null || refDiv === void 0 ? void 0 : (ref = refDiv.current) === null || ref === void 0 ? void 0 : ref.clientHeight);
        }
    }, []);
    var handleOnError = function(data) {
        setVideoError(data.isTrusted);
    };
    var playerConfig = {
        attributes: {
            height: videoHeight
        }
    };
    var endGame = function() {
        if (gameRef.current) clearTimeout(gameRef.current);
        gameRef.current = setTimeout(function() {
            setGameId(null);
            hideLotteryBtn();
            setGameStatus(layouts_shared/* LotteryGameStatus.Ended */.Ck.Ended);
        }, 10000);
    };
    (0,react.useEffect)(function() {
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* CommentMethod.ProcessingLucky */.iz.ProcessingLucky) {
            if (!messageData.data) return;
            setLucky(messageData.data);
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* CommentMethod.FinishLucky */.iz.FinishLucky) setLucky(null);
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LotterySocketMethod.OpenLottery */.Sf.OpenLottery) {
            var ref;
            setGameStatus(layouts_shared/* LotteryGameStatus.Pending */.Ck.Pending);
            setGameId(((ref = messageData.data) === null || ref === void 0 ? void 0 : ref.lottery_game_id) || "");
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LotterySocketMethod.EndLottery */.Sf.EndLottery) {
            endGame();
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LiveProductMethod.PinProduct */.zN.PinProduct) {
            var p = messageData.data.live_stream_product;
            if (p && p.product_id !== (pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.product_id)) {
                setPinnedProduct(p);
            }
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LiveProductMethod.AuctionStarted */.zN.AuctionStarted || (messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LiveProductMethod.AuctionEnded */.zN.AuctionEnded) {
            if (!messageData.data) return;
            setPinnedProduct(function(prev) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    products: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev.products), {
                        auction: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev.products.auction), {
                            ended_time_at: messageData.data.ended_time_at,
                            started_at: messageData.data.started_at,
                            status: messageData.data.status
                        })
                    })
                });
            });
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LiveProductMethod.AuctionOffer */.zN.AuctionOffer) {
            setPinnedProduct(function(prev) {
                if (!messageData.data) return;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    products: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev.products), {
                        auction: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev.products.auction), {
                            sell_price: messageData.data.sell_price || 0
                        })
                    })
                });
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        messageData
    ]);
    var renderLucky = function(type) {
        if (!type) return "";
        if (type == layouts_shared/* EventType.Gift */.tw.Gift) return "Qu\xe0 tặng";
        if (type == layouts_shared/* EventType.Wishes */.tw.Wishes) return "Lời ch\xfac";
        if (type == layouts_shared/* EventType.Voucher */.tw.Voucher) return "Voucher";
    };
    var checkMyAccount = function(type, userId) {
        if (type === layouts_shared/* EventType.Wishes */.tw.Wishes && userId === (profile === null || profile === void 0 ? void 0 : profile.id)) return false;
        return true;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-h-full tw-w-full tw-relative",
            style: {
                minHeight: "450px"
            },
            ref: refDiv,
            children: [
                isVideoError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-flex tw-justify-center tw-items-center tw-h-full",
                    children: t("detail.error")
                }),
                !isVideoError && videoHeight !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                    url: url,
                    width: "100%",
                    height: "100%",
                    className: "react-player",
                    style: {
                        textAlign: "center",
                        backgroundColor: "black"
                    },
                    ref: playerRef,
                    autoPlay: true,
                    muted: true,
                    playing: true,
                    controls: true,
                    onReady: function() {
                        var ref;
                        return (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.seekTo(start, "seconds");
                    },
                    onProgress: onVideoPlaying,
                    onError: handleOnError,
                    config: playerConfig,
                    onStart: function() {
                        return console.log("start");
                    },
                    onEnded: function() {
                        return console.log("end");
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                    children: lucky && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                        className: "tw-absolute tw-right-4 tw-bottom-20 tw-z-10",
                        initial: {
                            opacity: 0
                        },
                        animate: {
                            opacity: 1
                        },
                        exit: {
                            opacity: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LuckyPartial, {
                            lucky: lucky,
                            callRefetch: function() {
                                return refetchLucky();
                            }
                        })
                    })
                }),
                gameId && gameStatus !== layouts_shared/* LotteryGameStatus.Ended */.Ck.Ended && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-absolute tw-left-2 tw-top-4 md:tw-left-6 md:tw-top-16",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryPartial, {
                        isAuth: isAuth,
                        t: t,
                        gameId: gameId,
                        liveStreamId: liveStreamId,
                        messageData: messageData,
                        showLotteryBtn: showLotteryBtn,
                        gameStatus: gameStatus
                    })
                }),
                ((ref = pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.products.auction) === null || ref === void 0 ? void 0 : ref.status) === layouts_shared/* AuctionStatus.Started */.wo.Started && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-absolute tw-right-2 tw-top-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(player_AuctionCountDown, {
                        endTime: pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.products.auction.ended_time_at
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bubbling-heart tw-w-full tw-h-full tw-z-20",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                        children: sticker && [
                            1,
                            2,
                            3,
                            4
                        ].map(function(i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                className: "tw-w-7 tw-h-7 tw-rounded-full",
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                exit: {
                                    opacity: 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: sticker,
                                    className: "tw-w-full tw-h-full",
                                    alt: sticker
                                })
                            }, i);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-absolute tw-left-2 tw-bottom-3 tw-gap-y-2 tw-flex tw-flex-col",
                    children: [
                        !!messageData && messageData.method === layouts_shared/* LotterySocketMethod.AdminPickTicketLottery */.Sf.AdminPickTicketLottery && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                exit: {
                                    opacity: 0
                                },
                                className: "tw-bg-black tw-bg-opacity-30 tw-rounded-full tw-px-4 tw-py-1 tw-text-white tw-flex tw-items-center tw-text-base",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "Kết quả xổ số: ",
                                            messageData.data.number
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                        src: "/confetti-flat.gif",
                                        alt: "confetti",
                                        className: "tw-w-6 tw-h-6 tw-ml-1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                        src: "/confetti-flat.gif",
                                        alt: "confetti",
                                        className: "tw-w-6 tw-h-6 tw-ml-1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                        src: "/confetti-flat.gif",
                                        alt: "confetti",
                                        className: "tw-w-6 tw-h-6 tw-ml-1"
                                    })
                                ]
                            })
                        }),
                        !!messageData && messageData.method === layouts_shared/* CommentMethod.OpenLuckyBox */.iz.OpenLuckyBox && checkMyAccount(messageData === null || messageData === void 0 ? void 0 : messageData.data.type, (ref1 = messageData.data.users) === null || ref1 === void 0 ? void 0 : ref1.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                exit: {
                                    opacity: 0
                                },
                                className: "tw-bg-black tw-bg-opacity-30 tw-rounded-full tw-px-4 tw-py-1 tw-text-white tw-flex tw-items-center tw-text-base",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        messageData === null || messageData === void 0 ? void 0 : (ref2 = messageData.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.users) === null || ref3 === void 0 ? void 0 : ref3.fullname,
                                        " đ\xe3 mở được\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: renderLucky(messageData.data.type)
                                        })
                                    ]
                                })
                            })
                        }),
                        !!messageData && messageData.method === layouts_shared/* MessageMethodType.Sticker */.eu.Sticker && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                exit: {
                                    opacity: 0
                                },
                                className: "tw-bg-black tw-bg-opacity-30 tw-rounded-full tw-px-4 tw-py-1 tw-text-white tw-flex tw-items-center tw-text-base",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            messageData.data.fullname,
                                            " đ\xe3 tặng \xa0"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                        alt: messageData === null || messageData === void 0 ? void 0 : (ref4 = messageData.data) === null || ref4 === void 0 ? void 0 : ref4.sticker_icon,
                                        src: messageData === null || messageData === void 0 ? void 0 : (ref5 = messageData.data) === null || ref5 === void 0 ? void 0 : ref5.sticker_icon,
                                        className: "tw-w-6 tw-h-6 tw-rounded-full",
                                        objectFit: "cover"
                                    })
                                ]
                            })
                        }),
                        !!messageData && messageData.method === layouts_shared/* MessageMethodType.JoinLivestream */.eu.JoinLivestream && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                exit: {
                                    opacity: 0
                                },
                                className: "tw-px-4 tw-py-1 tw-text-white tw-flex tw-items-center tw-text-base",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            messageData.data.fullname,
                                            " đ\xe3 tham gia \xa0"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                        className: "tw-flex tw-items-center tw-justify-center",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* WaveIcon */.Lk, {})
                                    })
                                ]
                            })
                        }),
                        !!messageData && messageData.method === layouts_shared/* MessageMethodType.GiftAtd */.eu.GiftAtd && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                exit: {
                                    opacity: 0
                                },
                                className: "tw-px-4 tw-py-1 tw-text-white tw-flex tw-items-center tw-text-base",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            (ref6 = messageData.data.users) === null || ref6 === void 0 ? void 0 : ref6.fullname,
                                            " đ\xe3 tặng"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                        src: "/diamond-kam.png",
                                        alt: "diamond",
                                        className: "tw-w-4 tw-h-4 tw-mx-2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "tw-text-white tw-font-bold",
                                        children: [
                                            messageData.data.amount,
                                            " ATD"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                liveStatus === detail_const/* LiveStreamStatus.LIVE_NOW */.zN.LIVE_NOW && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-absolute tw-left-6 tw-top-[60px] tw-flex tw-items-center tw-px-4 tw-bg-red-600 tw-text-white tw-font-xs tw-rounded tw-mr-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-w-2 tw-h-2 tw-rounded-full tw-bg-white tw-mr-1 tw-block"
                        }),
                        "Live"
                    ]
                })
            ]
        })
    });
};
PlayerPartial.defaultProps = {
    products: [],
    prevPlayedSeconds: 0
};
/* harmony default export */ var player = (PlayerPartial);

// EXTERNAL MODULE: ./components/form/SearchVideo/index.tsx
var SearchVideo = __webpack_require__(89777);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95298);
;// CONCATENATED MODULE: ./features/livestream/detail/partials/breadcrumb/index.tsx


var BreadCrumbPartial = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-gap-x-2 tw-items-center tw-font-normal tw-text-base !tw-text-secondary-70",
        children: [
            "Trực tiếp \xa0",
            " > ",
            "\xa0",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "tw-line-clamp-1 tw-flex-1",
                children: title
            })
        ]
    });
};
/* harmony default export */ var breadcrumb = (/*#__PURE__*/(0,react.memo)(BreadCrumbPartial));

// EXTERNAL MODULE: ./components/ui/MetaTag/index.tsx
var MetaTag = __webpack_require__(42031);
// EXTERNAL MODULE: ./libs/cookies/index.ts + 1 modules
var cookies = __webpack_require__(47279);
;// CONCATENATED MODULE: ./features/livestream/detail/layout.tsx














var LiveVideoDetailLayout = function(param) {
    var liveVideo = param.liveVideo, isAuth = param.isAuth, collectionStickers = param.collectionStickers, comments = param.comments, offset = param.offset;
    var ref, ref1, ref2;
    var t = (0,esm/* useTranslation */.$G)([
        "live-video",
        "layout"
    ]).t;
    var getPinnedProduct = function(productsRange) {
        var ref;
        if (productsRange.length <= 0) return null;
        var p = productsRange.find(function(p) {
            return p.status === detail_const/* LiveStreamStatus.LIVE_NOW */.zN.LIVE_NOW;
        });
        if (p && p.product_id && ((ref = p.products) === null || ref === void 0 ? void 0 : ref.status) !== layouts_shared/* ProductStatus.Hide */.Pt.Hide) {
            return p;
        }
        return null;
    };
    var ref3 = (0,react.useState)(), pinnedProduct = ref3[0], setPinnedProduct = ref3[1];
    (0,react.useEffect)(function() {
        setPinnedProduct(getPinnedProduct(liveVideo.live_stream_product) || detail_const/* PinnedProductDefault */.UC);
    }, [
        liveVideo
    ]);
    var ref4 = (0,react.useState)(false), showLotteryBtn = ref4[0], setShowLotteryBtn = ref4[1];
    var ref5 = (0,react.useState)(null), message = ref5[0], setMessage = ref5[1];
    var ref6 = (0,react.useState)(null), waitingToReconnect = ref6[0], setWaitingToReconnect = ref6[1];
    var ref7 = (0,react.useState)(0), retry = ref7[0], setRetry = ref7[1];
    var ref8 = (0,react.useRef)(null);
    var timeOut = (0,react.useRef)(null);
    var clientRef = (0,react.useRef)(null);
    var ref9 = (0,api/* useFetchTrackingVideo */.yk)(liveVideo.id, {
        enabled: false,
        refetchOnWindowFocus: false
    }), refetchTracking = ref9.refetch;
    (0,react.useEffect)(function() {
        var ref = (0,cookies/* getAuth */.v0)(), isAuth = ref.isAuth, token = ref.token;
        if (waitingToReconnect) {
            return;
        }
        if (!isAuth) refetchTracking();
        if (isAuth && !clientRef.current) {
            var ws = new WebSocket("".concat("wss://api.anthu.tech/ws/realtime" || 0, "?token=").concat(token));
            clientRef.current = ws;
            ws.onopen = function() {
                var socketPayload = {
                    method: "subscribe",
                    type: "unicast",
                    channels: [
                        {
                            id: layouts_shared/* SocketChanel.LiveStream */.y1.LiveStream,
                            object_id: liveVideo.id
                        }
                    ]
                };
                ws.send(JSON.stringify(socketPayload));
                if (!retry) {
                    refetchTracking();
                    setRetry(function(prev) {
                        return prev + 1;
                    });
                }
                timeOut.current = setInterval(function() {
                    var socketPayload = {
                        method: "ping"
                    };
                    ws.send(JSON.stringify(socketPayload));
                }, 15000);
            };
            ws.onmessage = function(evt) {
                var m = JSON.parse(evt.data);
                if (m === null || m === void 0 ? void 0 : m.data) {
                    setMessage(m);
                    clearTimeout(ref8.current);
                }
                ref8.current = setTimeout(function() {
                    setMessage(null);
                }, 5000);
            };
            ws.onclose = function() {
                if (clientRef.current) {
                    console.log("ws closed by server");
                } else {
                    console.log("ws closed by app component unmount");
                }
                setWaitingToReconnect(true);
                setTimeout(function() {
                    return setWaitingToReconnect(null);
                }, 5000);
            };
            return function() {
                ws.close();
                console.log("closed");
                clearInterval(timeOut.current);
                timeOut.current = null;
                clientRef.current = null;
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        liveVideo.id,
        waitingToReconnect
    ]);
    var lotteryGame = ((ref = liveVideo.lottery_game) === null || ref === void 0 ? void 0 : ref.find(function(g) {
        return g.status !== layouts_shared/* LotteryGameStatus.Ended */.Ck.Ended;
    })) || null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTag/* default */.Z, {
                title: t("detail.title"),
                description: t("detail.title"),
                image: liveVideo.images[0].url || ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container tw-pt-8 tw-pb-12 tw-mx-auto md:tw-border-t tw-border-primary-main",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb, {
                        title: liveVideo.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: "tw-hidden",
                        children: [
                            " ",
                            liveVideo.name
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "tw-hidden",
                        children: [
                            " ",
                            liveVideo.name
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "tw-hidden",
                        children: [
                            " ",
                            liveVideo.description
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-mt-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-y-4 tw-gap-x-0 lg:tw-gap-x-4 lg:tw-gap-y-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "lg:tw-col-span-7 tw-relative tw-flex tw-flex-col",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchVideo/* default */.Z, {
                                                t: t
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tw-relative tw-mt-4 tw-h-full tw-flex tw-flex-1 tw-rounded-5 tw-overflow-hidden",
                                                children: liveVideo.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(player, {
                                                    url: liveVideo.link,
                                                    liveImage: (ref1 = liveVideo.images[0]) === null || ref1 === void 0 ? void 0 : ref1.url,
                                                    pinnedProduct: pinnedProduct,
                                                    setPinnedProduct: setPinnedProduct,
                                                    liveStreamId: liveVideo.id,
                                                    liveStatus: liveVideo.status,
                                                    productsRange: productsRangeBuilder(liveVideo.live_stream_product),
                                                    messageData: message,
                                                    lotteryGame: lotteryGame,
                                                    luckyDetail: liveVideo === null || liveVideo === void 0 ? void 0 : liveVideo.lucky,
                                                    t: t,
                                                    isAuth: isAuth,
                                                    showLotteryBtn: function() {
                                                        return setShowLotteryBtn(true);
                                                    },
                                                    hideLotteryBtn: function() {
                                                        return setShowLotteryBtn(false);
                                                    },
                                                    sticker: message === null || message === void 0 ? void 0 : (ref2 = message.data) === null || ref2 === void 0 ? void 0 : ref2.sticker_icon
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "lg:tw-col-span-5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chat, {
                                            hideLotteryBtn: function() {
                                                return setShowLotteryBtn(false);
                                            },
                                            showLotteryBtn: showLotteryBtn,
                                            liveStreamId: liveVideo.id,
                                            status: liveVideo.status,
                                            pinnedProduct: pinnedProduct,
                                            commentList: comments,
                                            isAuth: isAuth,
                                            collectionStickers: collectionStickers,
                                            messageData: message,
                                            lotteryGame: lotteryGame,
                                            defaultOffset: offset,
                                            products: liveVideo.live_stream_product,
                                            t: t,
                                            retry: waitingToReconnect || false
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-mt-16",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(list, {
                                    t: t
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var layout = (LiveVideoDetailLayout);

;// CONCATENATED MODULE: ./features/livestream/detail/index.ts

/* harmony default export */ var detail = (layout);


/***/ }),

/***/ 83134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ LiveVideosDefault; }
/* harmony export */ });
var LiveVideosDefault = {
    edges: [],
    count: 0
};


/***/ }),

/***/ 17852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mM": function() { return /* binding */ useRemindResellQuery; },
/* harmony export */   "uJ": function() { return /* binding */ useCreateChatConversation; },
/* harmony export */   "uK": function() { return /* binding */ useFetchConversationByProductQuery; }
/* harmony export */ });
/* unused harmony exports fetchProduct, fetchProductAuth, fetchConversationByProduct, createConversation, fetchAccountProfile, useFetchUserQuery, RemindResell */
/* harmony import */ var _libs_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80787);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88767);
/* harmony import */ var _layouts_shared__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7806);



var fetchProduct = function(id) {
    return axios.get("/api/v1/products/".concat(id));
};
var fetchProductAuth = function(id, token) {
    return axios.get("/api/v1/products/".concat(id), {
        headers: {
            Authorization: "Bearer ".concat(token)
        }
    });
};
var fetchConversationByProduct = function(id) {
    return _libs_axios__WEBPACK_IMPORTED_MODULE_0__/* .AxiosChatInstance.get */ .WA.get("/v2/me/chat/conversations/type/product/".concat(id));
};
var createConversation = function(payload) {
    return _libs_axios__WEBPACK_IMPORTED_MODULE_0__/* .AxiosChatInstance.post */ .WA.post("/v2/me/chat/conversations", payload);
};
var useCreateChatConversation = function(options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useMutation)(function(payload) {
        return createConversation(payload);
    }, options);
};
var useFetchConversationByProductQuery = function(id, options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([
        _layouts_shared__WEBPACK_IMPORTED_MODULE_2__/* .QueryKey.Conversations */ .S8.Conversations,
        id
    ], function() {
        return fetchConversationByProduct(id);
    }, options);
};
var fetchAccountProfile = function() {
    return axios.get("/api/v1/user/profile");
};
var useFetchUserQuery = function(options) {
    return useQuery([
        QueryKey.Users
    ], function() {
        return fetchAccountProfile();
    }, options);
};
var RemindResell = function(payload) {
    return _libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/api/v1/products/remind/resell", payload);
};
var useRemindResellQuery = function(options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useMutation)(function(payload) {
        return RemindResell(payload);
    }, options);
};


/***/ })

}]);